// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.empresas-page {
  min-height: 100vh;
  background: #f5f7fb;
}

.empresas-heading {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 18px;
}

.empresas-heading-actions {
  --empresas-control-height: 38px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.empresas-primary-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 0;
  padding: 10px 20px;
  border-radius: 5px;
  background: #006699;
  color: #fff;
  font-weight: 600;
}

.empresas-primary-button:hover,
.empresas-primary-button:focus {
  background: #00527a;
  color: #fff;
}

.empresas-heading-actions .empresas-create-button {
  height: var(--empresas-control-height);
  min-height: var(--empresas-control-height);
  padding-block: 0;
  white-space: nowrap;
}

.empresas-heading h4 {
  color: #263b50;
}

.empresas-subtitle {
  margin: 0;
  color: #71859a;
  font-size: 13px;
}

.empresas-search {
  width: min(340px, 100%);
  height: var(--empresas-control-height);
  border: 1px solid #cbd5df;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}

.empresas-search .input-group-text {
  border: 0;
  border-right: 1px solid #e1e8ef;
  background: #fff;
  color: #71879b;
}

.empresas-search .form-control {
  border: 0;
  box-shadow: none;
}

.empresas-table-card {
  overflow: hidden;
  border: 0;
  border-radius: 12px;
  box-shadow: 0 4px 18px rgba(31, 55, 80, .08);
}

.empresas-table-wrapper {
  max-height: calc(100vh - 230px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.empresas-table {
  min-width: 520px;
  margin: 0;
}

.empresas-table thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  padding: 13px 18px;
  white-space: nowrap;
  background: #006699 !important;
  color: #fff !important;
  font-size: 12px;
  letter-spacing: .04em;
}

.empresas-table tbody td {
  padding: 14px 18px;
  vertical-align: middle;
  color: #536b83;
}

.empresas-table tbody td:first-child {
  width: 110px;
  color: #49647e;
}

.empresas-table tbody tr:hover {
  background: #f1f7fb;
}

.empresas-actions-heading,
.empresas-actions-cell {
  width: 88px;
  text-align: center;
}

.empresas-actions-heading {
  font-size: 0 !important;
}

.empresas-actions-cell {
  position: relative;
}

.empresas-row-menu {
  position: relative;
  display: inline-block;
}

.empresas-dots-button {
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: #006699;
}

.empresas-dots-button:hover,
.empresas-dots-button:focus {
  background: #eaf3f8;
  outline: none;
}

.empresas-dropdown {
  position: fixed;
  z-index: 1200;
  min-width: 170px;
  max-width: calc(100vw - 24px);
  padding: 6px;
  border: 1px solid #dce6ee;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 8px 22px rgba(32, 59, 83, .18);
  text-align: left;
}

.empresas-modal-backdrop {
  position: fixed;
  z-index: 1100;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(27, 43, 57, .55);
}

.empresas-base-modal .modal-body {
  padding: 0;
  display: flex;
  min-height: 0;
  overflow: hidden;
}

.empresas-base-modal .modal-content {
  display: flex;
  flex-direction: column;
  max-height: min(850px, 92vh);
}

.empresas-base-modal .modal-header {
  flex: 0 0 auto;
}

.empresas-base-modal .modal-body {
  flex: 1 1 auto;
}

.empresas-modal-shell {
  display: flex;
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
}

.empresas-modal-shell > form {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
  width: 100%;
}

.empresas-modal-content {
  flex: 1 1 auto;
  min-height: 0;
  max-height: min(780px, 82vh);
  padding: 12px 18px 0;
  overflow-y: auto;
  overflow-x: hidden;
  background: #fff;
}

.empresas-modal {
  width: min(900px, 100%);
  max-height: min(850px, 92vh);
  overflow-y: auto;
  border: 1px solid rgba(67, 89, 113, .2);
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 16px 48px rgba(13, 43, 66, .3);
}

.empresas-modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 22px 26px 16px;
  border-bottom: 1px solid #e8eef3;
}

.empresas-modal-kicker {
  display: block;
  margin-bottom: 5px;
  color: #08719f;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: .08em;
  text-transform: uppercase;
}

.empresas-modal-header h5 {
  margin: 0;
  color: #263b50;
  font-size: 21px;
}

.empresas-modal-close {
  width: 34px;
  height: 34px;
  border: 0;
  border-radius: 50%;
  background: #eef4f8;
  color: #526d84;
}

.empresas-modal-close:hover { background: #dfeaf1; }

.empresas-modal-content form,
.empresas-negociaciones-modal > .empresas-negotiation-grid,
.empresas-negociaciones-modal > .empresas-negotiation-checks,
.empresas-negociaciones-modal > .empresas-notes {
  padding: 12px 18px 0;
}

.empresas-form-grid,
.empresas-negotiation-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 7px;
}

.empresas-form-section,
.empresas-form-section-grid {
  display: contents;
}

.empresas-form-section-title {
  display: none;
}

.empresas-modal-heading {
  display: inline-flex;
  min-width: 0;
  align-items: center;
  gap: 10px;
}

.empresas-modal-heading > i {
  display: grid;
  width: 32px;
  height: 32px;
  flex: 0 0 32px;
  place-items: center;
  border-radius: 9px;
  background: #eaf3f9;
  color: #0874a7;
  font-size: 20px;
}

.empresas-modal-heading > span {
  display: grid;
  min-width: 0;
  gap: 2px;
}

.empresas-modal-heading strong,
.empresas-modal-heading small {
  overflow: hidden;
  text-overflow: ellipsis;
}

.empresas-modal-heading strong {
  color: #294b69;
  font-size: 18px;
  font-weight: 700;
}

.empresas-modal-heading small {
  color: #8195a8;
  font-size: 11px;
  font-weight: 500;
}

.empresas-negotiation-section {
  min-width: 0;
}

.empresas-negotiation-section-title {
  display: none;
}

.empresas-form-field,
.empresas-negotiation-grid label,
.empresas-form-options label,
.empresas-notes {
  display: grid;
  grid-template-columns: 145px minmax(0, 1fr);
  align-items: center;
  gap: 7px;
  color: #425d75;
  font-size: 11px;
  font-weight: 600;
}

.empresas-form-field b { color: #c14848; }
.empresas-form-field-wide { grid-column: 1 / -1; }

/* Misma base visual de los formularios de actualización de contratos. */
.empresas-base-modal .empresas-form-field > .Label,
.empresas-base-modal .empresas-form-options > label > .Label {
  margin: 0;
  color: #000;
  font-size: 15px;
  font-weight: 700;
}

.empresas-base-modal .Input,
.empresas-base-modal .InputSelect {
  width: 100%;
  min-height: 20px;
  height: 20px;
  box-sizing: border-box;
  padding: 0 10px;
  border: 1px solid #000;
  border-radius: 4px;
  background: #fff;
  color: #000;
  font-size: 15px;
  line-height: 1;
  box-shadow: none;
}

.empresas-base-modal .Input:focus,
.empresas-base-modal .InputSelect:focus {
  border-color: #000;
  box-shadow: none;
}

.empresas-identification-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 18px minmax(90px, .32fr);
  grid-column: 1 / -1;
  order: 5;
  align-items: end;
  gap: 10px;
}

.empresas-form-grid > .empresas-form-field:nth-child(n + 6) {
  order: 6;
}

.empresas-identification-separator {
  padding-bottom: 6px;
  color: #425d75;
  font-size: 16px;
  text-align: center;
}

.empresas-verification-field {
  display: block;
}

.empresas-form-field input,
.empresas-form-field select,
.empresas-negotiation-grid input,
.empresas-negotiation-grid select,
.empresas-form-options select,
.empresas-notes textarea {
  min-height: 32px;
  padding: 5px 8px;
  border: 1px solid #cbd8e2;
  border-radius: 6px;
  background: #fff;
  color: #334f68;
  outline: none;
}

.empresas-form-field input,
.empresas-form-field select,
.empresas-negotiation-grid input,
.empresas-negotiation-grid select,
.empresas-form-options select {
  box-sizing: border-box;
  width: 100%;
  font-family: inherit;
  font-size: 13px;
}

.empresas-form-field input:focus,
.empresas-form-field select:focus,
.empresas-negotiation-grid input:focus,
.empresas-negotiation-grid select:focus,
.empresas-form-options select:focus,
.empresas-notes textarea:focus { border-color: #1683b5; box-shadow: 0 0 0 3px rgba(22, 131, 181, .12); }

.empresas-form-field select:disabled {
  cursor: not-allowed;
  background-color: #f1f4f7;
  color: #526b82;
  opacity: 1;
}

.empresas-form-options {
  display: flex;
  align-items: flex-end;
  gap: 25px;
  padding: 12px 0 0;
}

.empresas-report-type {
  display: flex;
  align-items: center;
  gap: 16px;
  min-width: 260px;
  margin: 0;
  padding: 0;
  border: 0;
  color: #425d75;
  font-size: 13px;
  font-weight: 600;
}

.empresas-report-type legend {
  float: left;
  width: auto;
  margin: 0 14px 0 0;
  color: #425d75;
  font-size: 12px;
  font-weight: 600;
}

.empresas-report-type label {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
  min-height: 38px;
  color: #425d75;
  font-size: 13px;
  font-weight: 400;
}

.empresas-report-type input {
  accent-color: #006699;
}

.empresas-check,
.empresas-negotiation-checks label {
  display: flex !important;
  flex-direction: row !important;
  align-items: center;
  min-height: 38px;
}
.empresas-check input,
.empresas-negotiation-checks input { accent-color: #0875aa; }

.empresas-switch {
  display: inline-flex !important;
  flex-direction: row !important;
  align-items: center;
  gap: 8px !important;
  min-height: 38px;
  color: #425d75;
  cursor: pointer;
}

.empresas-switch input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
}

.empresas-switch-track {
  position: relative;
  display: inline-flex;
  width: 38px;
  height: 21px;
  flex: 0 0 auto;
  border-radius: 20px;
  background: #b9c6d0;
  transition: background .2s ease;
}

.empresas-switch-thumb {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(20, 45, 64, .25);
  transition: transform .2s ease;
}

.empresas-switch input:checked + .empresas-switch-track {
  background: #006699;
}

.empresas-switch input:checked + .empresas-switch-track .empresas-switch-thumb {
  transform: translateX(17px);
}

.empresas-modal-footer {
  flex: 0 0 auto;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 14px 18px;
  border-top: 1px solid #e8eef3;
  margin-top: 14px;
}

.empresas-negotiation-checks { display: flex; gap: 24px; color: #425d75; font-size: 13px; }
.empresas-notes { padding-bottom: 0 !important; }
.empresas-notes textarea { min-height: 84px; resize: vertical; }
.empresas-negotiation-table {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  min-height: 0;
  height: auto;
  max-height: none;
  /* El espacio inferior no debe consumir la altura disponible de la grilla. */
  margin: 0 26px 20px;
  padding-bottom: 0;
  padding-top: 0;
  background: #fff;
  color: #425d75;
  font-size: 13px;
  overflow: hidden;
}
.empresas-empty-mini { margin-top: 10px; color: #8092a3; font-size: 12px; }

.empresas-negotiation-results {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
  height: auto !important;
  max-height: none;
  width: 100%;
  max-width: 100%;
  margin-top: 0;
  background: #fff;
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-width: thin;
}

.empresas-negotiation-results .empresas-table tbody {
  display: table-row-group !important;
  visibility: visible !important;
}

.empresas-negotiation-results .empresas-table tbody tr {
  display: table-row !important;
  visibility: visible !important;
}

.empresas-negotiation-results thead th {
  position: sticky;
  top: 0;
  z-index: 1;
}

.empresas-negotiation-results .empresas-table {
  width: 100%;
  min-width: 0;
  table-layout: fixed;
  margin-bottom: 0;
  background: #fff;
}

.empresas-negotiation-results .empresas-table tbody,
.empresas-negotiation-results .empresas-table tbody tr,
.empresas-negotiation-results .empresas-table tbody td {
  background: #fff !important;
}

.empresas-negotiation-results .empresas-table th,
.empresas-negotiation-results .empresas-table td {
  overflow: hidden;
  padding: 10px 8px;
  text-overflow: ellipsis;
  vertical-align: middle;
}

.empresas-negotiation-results .empresas-table th:nth-child(1),
.empresas-negotiation-results .empresas-table td:nth-child(1) { width: 27%; }

.empresas-negotiation-results .empresas-table th:nth-child(2),
.empresas-negotiation-results .empresas-table td:nth-child(2) { width: 16%; }

.empresas-negotiation-results .empresas-table th:nth-child(3),
.empresas-negotiation-results .empresas-table td:nth-child(3) { width: 17%; }

.empresas-negotiation-results .empresas-table th:nth-child(4),
.empresas-negotiation-results .empresas-table td:nth-child(4) { width: 12%; }

.empresas-negotiation-results .empresas-table th:nth-child(5),
.empresas-negotiation-results .empresas-table td:nth-child(5) { width: 13%; }

.empresas-negotiation-results .empresas-table th:nth-child(6),
.empresas-negotiation-results .empresas-table td:nth-child(6) { width: 8%; }

.empresas-negotiation-results .empresas-table th:nth-child(1),
.empresas-negotiation-results .empresas-table td:nth-child(1) {
  white-space: normal;
  word-break: break-word;
}

.empresas-negotiation-results .empresas-table th {
  color: #fff;
}

.empresas-negotiation-actions-heading,
.empresas-negotiation-actions-cell {
  width: 48px;
  text-align: center;
}

.empresas-negotiation-actions-cell button {
  padding: 2px 6px;
  border: 0;
  background: transparent;
  color: #006699;
  font-size: 20px;
  line-height: 1;
}

.empresas-negociaciones-modal .empresas-negotiation-switches {
  align-items: center;
  min-height: 32px;
}

.empresas-negociaciones-modal .empresas-switch {
  min-height: 28px;
  gap: 7px !important;
  color: #425d75;
  font-size: 13px;
}

.empresas-negociaciones-modal .empresas-switch-track {
  width: 36px;
  height: 20px;
}

.empresas-negociaciones-modal .empresas-switch-thumb {
  width: 14px;
  height: 14px;
}

.empresas-negociaciones-modal .empresas-switch input:checked + .empresas-switch-track .empresas-switch-thumb {
  transform: translateX(16px);
}

/* react-select tiene un input interno para la búsqueda. Las reglas
   generales del formulario no deben aplicarle la altura de 32px. */
.empresas-base-modal .empresas-form-field .transportador-select__control {
  min-height: 38px !important;
  height: 38px !important;
  border: 1px solid #cbdce8 !important;
  border-radius: 9px !important;
}

.empresas-base-modal .empresas-form-field .transportador-select__value-container {
  height: 36px !important;
  min-height: 36px !important;
  padding: 0 10px !important;
  overflow: hidden;
}

.empresas-base-modal .empresas-form-field .transportador-select__input-container,
.empresas-base-modal .empresas-form-field .transportador-select__input {
  height: 36px !important;
  min-height: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
  line-height: 36px !important;
}

.empresas-base-modal .empresas-form-field .transportador-select__single-value,
.empresas-base-modal .empresas-form-field .transportador-select__placeholder {
  line-height: 36px !important;
  margin: 0 !important;
  white-space: nowrap;
}

.empresas-base-modal .empresas-form-field .transportador-select__indicators,
.empresas-base-modal .empresas-form-field .transportador-select__indicators-container {
  height: 36px !important;
}

/* Estructura del formulario de negociaciones basada en el modal de monitoreo. */
.empresas-negociaciones-modal.monitoreo-modern {
  --empresas-negotiation-bottom-space: 20%;
  height: 100% !important;
  min-height: 0;
  width: 100%;
  box-sizing: border-box;
  padding: 10px 18px 18px;
  background: transparent;
  overflow-x: hidden;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
}

/* El modal de negociaciones comparte la misma base visual del modal de
   monitoreo: encabezado limpio, fondo suave y contenido sin desbordes. */
.empresas-negociaciones-base-modal .modal-content {
  height: min(850px, 92vh);
  border: 0;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.26);
}

.empresas-negociaciones-base-modal .modal-header {
  padding: 16px 24px 12px;
  border-bottom: 0;
  background: #fff;
  color: #0f172a;
}

.empresas-negociaciones-base-modal .modal-header .modal-title {
  color: #526a83;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.3;
}

.empresas-negociaciones-base-modal .modal-body {
  display: flex;
  flex: 1 1 auto;
  height: 0;
  min-width: 0;
  min-height: 0;
  background: linear-gradient(180deg, #f7fbff 0%, #eff5fc 100%);
  overflow: hidden !important;
}

.empresas-negociaciones-modal .monitoreo-form-card {
  margin: 0;
  padding: 10px 8px;
  border-radius: 12px;
  background: #f9fcff;
}

.empresas-negociaciones-modal .empresas-negotiation-grid {
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.empresas-negociaciones-modal .empresas-negotiation-field {
  display: grid;
  grid-template-columns: 145px minmax(0, 1fr);
  align-items: center;
  gap: 7px;
  width: 100%;
  margin: 0;
  color: #000;
  font-size: 12px;
  font-weight: 700;
}

.empresas-time-range {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.empresas-time-range .Input {
  min-width: 0;
  flex: 1 1;
}

.empresas-time-range > span {
  flex: 0 0 auto;
  color: #526a83;
  font-weight: 600;
}

.empresas-negociaciones-modal .empresas-negotiation-field > span,
.empresas-negociaciones-modal .empresas-notes > span {
  align-self: center;
}

.empresas-negociaciones-modal .Input,
.empresas-negociaciones-modal .InputSelectReportSeguimihnetoSol,
.empresas-negociaciones-modal .TextAreaReportSe {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  border: 1px solid #cfe0f0;
  border-radius: 10px;
  background: #fff;
  color: #334f68;
  font-family: inherit;
  font-size: 13px;
  outline: none;
}

.empresas-negociaciones-modal .Input,
.empresas-negociaciones-modal .InputSelectReportSeguimihnetoSol {
  height: 32px;
  min-height: 32px;
  margin: 0;
  padding: 5px 10px;
  box-shadow: none;
}

.empresas-negociaciones-modal .TextAreaReportSe {
  min-height: 64px;
  height: 64px;
  padding: 8px 10px;
  resize: vertical;
  box-shadow: none;
}

.empresas-negociaciones-modal .Input:focus,
.empresas-negociaciones-modal .InputSelectReportSeguimihnetoSol:focus,
.empresas-negociaciones-modal .TextAreaReportSe:focus {
  border-color: #86b7fe;
  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.12);
}

.empresas-negociaciones-modal .empresas-negotiation-checks {
  margin: 8px 0 0;
  padding: 0 8px;
  gap: 24px;
  color: #425d75;
  font-size: 13px;
}

.empresas-negociaciones-modal .empresas-negotiation-notes {
  grid-template-columns: 145px minmax(0, 1fr);
  margin: 8px 0 0;
  padding: 0 8px !important;
  font-size: 12px;
  font-weight: 700;
}

.empresas-negociaciones-modal .empresas-modal-footer {
  margin-top: 12px;
  margin-left: 26px;
  margin-right: 26px;
  padding: 14px 0;
}

.empresas-negociaciones-modal .empresas-modal-footer .Button {
  min-width: 120px;
  margin: 0;
}

.empresas-negociaciones-modal .empresas-modal-footer .btn-light {
  color: #425d75;
  background: #fff;
  border: 0;
}

.empresas-negociaciones-modal .empresas-modal-footer .monitoreo-primary-btn {
  min-width: 190px;
  border-radius: 10px !important;
}

.empresas-state {
  padding: 42px 20px !important;
  color: #71859a !important;
  text-align: center;
}

.empresas-state-error {
  color: #b44c4c !important;
}

.empresas-result-count {
  padding: 9px 18px;
  border-top: 1px solid #edf2f6;
  color: #8092a3;
  font-size: 12px;
  text-align: right;
}

/* Presentación moderna del formulario de empresa. El modal de negociaciones
   conserva su propia densidad y estilos de monitoreo. */
.empresas-base-modal:not(.empresas-negociaciones-base-modal) .modal-dialog {
  width: min(760px, calc(100vw - 32px));
  max-width: 760px;
}

.empresas-base-modal:not(.empresas-negociaciones-base-modal) .modal-content {
  overflow: hidden;
  border: 1px solid #dbe7ef;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 10px 26px rgba(31, 55, 80, .18);
}

.empresas-base-modal:not(.empresas-negociaciones-base-modal) .modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 22px 24px 16px;
  border-bottom: 0;
  background: #fff;
}

.empresas-base-modal:not(.empresas-negociaciones-base-modal) .modal-header h5 {
  color: #526a83;
  font-size: 20px;
  font-weight: 500;
}

.empresas-base-modal:not(.empresas-negociaciones-base-modal) .modal-body,
.empresas-base-modal:not(.empresas-negociaciones-base-modal) .empresas-modal-content {
  background: #fff;
}

.empresas-base-modal:not(.empresas-negociaciones-base-modal) .empresas-modal-content {
  padding: 20px 26px 4px;
}

.empresas-base-modal:not(.empresas-negociaciones-base-modal) .empresas-form-grid {
  gap: 11px;
}

.empresas-base-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field {
  grid-template-columns: 150px minmax(0, 1fr);
  gap: 14px;
  color: #243f59;
  font-size: 13px;
}

.empresas-base-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field > .Label,
.empresas-base-modal:not(.empresas-negociaciones-base-modal) .empresas-form-options > label > .Label {
  color: #294c6b;
  font-size: 13px;
  font-weight: 700;
}

.empresas-base-modal:not(.empresas-negociaciones-base-modal) .Input,
.empresas-base-modal:not(.empresas-negociaciones-base-modal) .InputSelect,
.empresas-base-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field input,
.empresas-base-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field select {
  min-height: 38px;
  height: 38px;
  padding: 7px 12px;
  border: 1px solid #cbdce8;
  border-radius: 9px;
  color: #304f6b;
  font-size: 14px;
  line-height: 1.2;
  transition: border-color .18s ease, box-shadow .18s ease, background-color .18s ease;
}

.empresas-base-modal:not(.empresas-negociaciones-base-modal) .Input:focus,
.empresas-base-modal:not(.empresas-negociaciones-base-modal) .InputSelect:focus,
.empresas-base-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field input:focus,
.empresas-base-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field select:focus {
  border-color: #1683b5;
  box-shadow: 0 0 0 3px rgba(22, 131, 181, .13);
}

.empresas-base-modal:not(.empresas-negociaciones-base-modal) .empresas-modal-footer {
  gap: 12px;
  padding: 16px 26px 20px;
  border-top: 1px solid #e5edf3;
  background: #f8fbfd;
}

.empresas-base-modal:not(.empresas-negociaciones-base-modal) .empresas-modal-footer .btn {
  min-height: 42px;
  padding: 9px 22px;
  border-radius: 9px;
  font-weight: 600;
}

/* El formulario de empresa usa la misma base de modal, pero una distribución
   compacta en escritorio para mostrar todos los campos sin scroll interno. */
.empresas-base-modal.empresas-compact-modal:not(.empresas-negociaciones-base-modal) .modal-dialog {
  width: min(900px, calc(100vw - 40px));
  max-width: 900px;
}

.empresas-base-modal.empresas-compact-modal:not(.empresas-negociaciones-base-modal) .modal-content {
  max-height: none;
}

.empresas-base-modal.empresas-compact-modal:not(.empresas-negociaciones-base-modal) .modal-body,
.empresas-base-modal.empresas-compact-modal:not(.empresas-negociaciones-base-modal) .empresas-modal-content {
  overflow: visible;
  max-height: none;
}

.empresas-base-modal.empresas-compact-modal:not(.empresas-negociaciones-base-modal) .empresas-form-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 22px;
  row-gap: 9px;
}

.empresas-base-modal.empresas-compact-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field {
  grid-template-columns: 150px minmax(0, 1fr);
  gap: 8px;
}

.empresas-base-modal.empresas-compact-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field > .Label,
.empresas-base-modal.empresas-compact-modal:not(.empresas-negociaciones-base-modal) .empresas-form-options > label > .Label {
  min-width: 0;
  white-space: nowrap;
  font-size: 12px;
  line-height: 1.2;
}

.empresas-base-modal.empresas-compact-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field input,
.empresas-base-modal.empresas-compact-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field select,
.empresas-base-modal.empresas-compact-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field .transportador-select__container {
  min-width: 0;
  width: 100%;
}

.empresas-base-modal.empresas-compact-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field-wide,
.empresas-base-modal.empresas-compact-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field-full,
.empresas-base-modal.empresas-compact-modal:not(.empresas-negociaciones-base-modal) .empresas-identification-row {
  grid-column: 1 / -1;
}

.empresas-base-modal.empresas-compact-modal:not(.empresas-negociaciones-base-modal) .empresas-modal-content {
  padding: 14px 24px 4px;
}

.empresas-base-modal.empresas-compact-modal:not(.empresas-negociaciones-base-modal) .empresas-modal-footer {
  padding: 12px 24px 16px;
}

/* Variante compacta basada en el mockup clásico. Se mantiene separada de la
   variante fresca para poder alternarlas desde la pantalla de empresas. */
.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .modal-dialog {
  width: min(620px, calc(100vw - 32px));
  max-width: 620px;
}

.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .modal-content {
  max-height: none;
  border: 1px solid #dbe7ef;
  border-radius: 8px;
  overflow: hidden;
}

.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .modal-header {
  padding: 18px 22px 12px;
}

.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .modal-header h5 {
  color: #526a83;
  font-size: 20px;
  font-weight: 500;
}

.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .modal-body,
.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .empresas-modal-content {
  max-height: none;
  overflow: visible;
}

.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .empresas-modal-content {
  padding: 8px 20px 0;
}

.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .empresas-form-grid {
  grid-template-columns: 1fr;
  gap: 7px;
}

.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field {
  grid-template-columns: 145px minmax(0, 1fr);
  gap: 8px;
  color: #000;
  font-size: 15px;
}

.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field > .Label,
.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .empresas-form-options > label > .Label {
  color: #000;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.15;
  white-space: normal;
}

.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .Input,
.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .InputSelect,
.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field input,
.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field select {
  min-width: 0;
  min-height: 20px;
  height: 20px;
  padding: 0 10px;
  border: 1px solid #000;
  border-radius: 4px;
  color: #000;
  font-size: 15px;
  line-height: 1;
}

.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field .transportador-select__control {
  min-height: 20px !important;
  height: 20px !important;
  border: 1px solid #000 !important;
  border-radius: 4px !important;
  box-shadow: none !important;
}

.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field .transportador-select__value-container,
.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field .transportador-select__indicators {
  height: 20px !important;
  min-height: 20px !important;
}

.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field .transportador-select__value-container {
  padding: 0 10px !important;
  display: flex !important;
  align-items: center !important;
  overflow: hidden !important;
}

.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field .transportador-select__single-value,
.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field .transportador-select__placeholder {
  position: static !important;
  transform: none !important;
  display: flex !important;
  align-items: center !important;
  height: 20px !important;
  margin: 0;
  color: #777;
  font-size: 15px;
  line-height: 20px !important;
}

.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field .transportador-select__container {
  margin-bottom: 0 !important;
}

.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field .transportador-select__input-container,
.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field .transportador-select__input {
  display: flex !important;
  align-items: center !important;
  margin: 0 !important;
  padding: 0 !important;
  height: 20px !important;
  line-height: 20px !important;
}

.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .empresas-identification-row {
  grid-template-columns: minmax(0, 1fr) 18px minmax(90px, .32fr);
  gap: 10px;
}

.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .empresas-form-options {
  padding: 8px 0 0;
}

.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .empresas-modal-footer {
  gap: 10px;
  padding: 12px 20px 14px;
}

.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .empresas-modal-footer .btn {
  min-height: 40px;
  padding: 8px 18px;
  border-radius: 5px;
  font-weight: 500;
}

.empresas-modal-variant-select {
  width: auto;
  min-width: 145px;
}

.empresas-mobile-cards {
  display: none;
}

@media (max-width: 1199px) {
  body.empresas-responsive-page #root {
    margin-left: 0 !important;
    overflow-x: hidden;
  }

  .empresas-page #layout-navbar.custom-navbar-admin {
    background: transparent !important;
    background-color: transparent !important;
    background-image: none !important;
    box-shadow: none !important;
  }

  .empresas-page #layout-navbar {
    min-height: 64px;
    padding: 4px 12px 4px 8px;
  }

  .empresas-page #layout-navbar .app-brand-link {
    min-width: 0;
    flex: 1 1 auto;
  }

  .empresas-page #layout-navbar .app-brand-link img {
    width: min(190px, 100%);
    height: 56px !important;
    object-fit: contain;
    object-position: left center;
  }
}

@media (max-width: 767px) {
  /* En móvil el modal funciona como bottom sheet: la X solo aparece
     cuando el contenido está completamente expandido. */
  .modal.empresas-negociaciones-base-modal .modal-dialog > .modal-content > .modal-header {
    display: flex !important;
    flex-direction: column;
    align-items: stretch;
    height: auto;
    min-height: 26px;
    padding: 8px 0 10px !important;
    pointer-events: none;
  }

  .modal.empresas-negociaciones-base-modal .modal-dialog > .modal-content > .modal-header .btn-close {
    position: absolute !important;
    top: 50px !important;
    right: 16px !important;
    z-index: 1101 !important;
    display: grid !important;
    width: 38px;
    height: 38px;
    margin: 0;
    padding: 0;
    border: 0;
    border-radius: 50%;
    background-color: #edf2f8;
    background-size: 14px;
    opacity: 1;
    pointer-events: auto;
  }

  .modal.empresas-negociaciones-base-modal .modal-dialog > .modal-content {
    position: relative;
  }

  .empresas-base-modal .modal-content {
    position: relative;
    max-height: min(82dvh, 760px);
  }

  .empresas-base-modal .modal-body {
    max-height: none !important;
    overflow: hidden !important;
  }

  .empresas-base-modal .empresas-modal-content {
    max-height: none;
  }

  .empresas-base-modal.responsive-modal-sheet-expanded .modal-content {
    max-height: 100dvh;
  }

  /* Igual que el modal de permisos: el botón pertenece al modal-content y
     queda fuera del área que hace scroll, no dentro del contenido. */
  .modal.empresas-negociaciones-base-modal.responsive-modal-sheet-expanded
    .modal-dialog > .modal-content > .modal-header .btn-close {
    position: absolute !important;
    top: 50px !important;
    right: 16px !important;
    z-index: 1101 !important;
    display: grid !important;
    width: 38px;
    height: 38px;
    margin: 0;
    padding: 0;
    border: 0;
    border-radius: 50%;
    background-color: #edf2f8;
    background-size: 14px;
    opacity: 1;
  }

  .modal.empresas-negociaciones-base-modal:not(.responsive-modal-sheet-expanded)
    .modal-dialog > .modal-content > .modal-header .btn-close {
    display: none !important;
  }

  .empresas-page {
    min-height: 100dvh;
  }

  .empresas-page #layout-navbar {
    min-height: 60px;
    padding: 4px 8px;
  }

  .empresas-page #layout-navbar .app-brand-link img {
    width: min(172px, 100%);
    height: 48px !important;
  }

  .empresas-page .content-wrapper {
    padding-bottom: calc(76px + env(safe-area-inset-bottom));
  }

  .empresas-heading {
    align-items: stretch;
    flex-direction: column;
    gap: 12px;
  }

  .empresas-heading-actions {
    --empresas-control-height: 42px;
    align-items: stretch;
    flex-direction: column;
  }

  .empresas-create-button { width: 100%; }

  .empresas-heading h4 {
    margin-bottom: 2px !important;
    text-align: center;
  }

  .empresas-subtitle {
    text-align: center;
  }

  .empresas-search {
    width: 100%;
  }

  .empresas-table-wrapper {
    max-height: calc(100dvh - 245px);
  }

  .empresas-table {
    min-width: 0;
  }

  .empresas-table thead th,
  .empresas-table tbody td {
    padding: 12px 14px;
  }

  .empresas-table tbody td:first-child {
    width: 72px;
  }

  .empresas-modal-backdrop {
    align-items: flex-end;
    padding: 0;
  }

  .empresas-modal {
    width: 100%;
    max-height: 94dvh;
    border-radius: 18px 18px 0 0;
  }

  .empresas-modal-header { padding: 20px 18px 14px; }
  .empresas-modal-header h5 { font-size: 18px; }
  .empresas-base-modal:not(.empresas-negociaciones-base-modal) .modal-header { padding: 18px; }
  .empresas-base-modal:not(.empresas-negociaciones-base-modal) .empresas-modal-content { padding: 18px; }
  .empresas-base-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field { grid-template-columns: 1fr; gap: 6px; }
  .empresas-base-modal:not(.empresas-negociaciones-base-modal) .empresas-modal-footer { padding: 14px 18px 18px; }
  .empresas-base-modal.empresas-compact-modal:not(.empresas-negociaciones-base-modal) .empresas-form-grid {
    grid-template-columns: 1fr;
    row-gap: 10px;
  }
  .empresas-base-modal.empresas-compact-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field {
    grid-template-columns: 1fr;
    gap: 6px;
  }
  .empresas-base-modal.empresas-compact-modal:not(.empresas-negociaciones-base-modal) .empresas-modal-content {
    padding: 18px;
  }
  .empresas-modal-content form,
  .empresas-negociaciones-modal > .empresas-negotiation-grid,
  .empresas-negociaciones-modal > .empresas-negotiation-checks,
  .empresas-negociaciones-modal > .empresas-notes { padding-left: 18px; padding-right: 18px; }
  .empresas-modal-content { padding-left: 18px; padding-right: 18px; }
  .empresas-form-grid,
  .empresas-negotiation-grid { grid-template-columns: 1fr; gap: 12px; }
  .empresas-form-field,
  .empresas-negotiation-grid label,
  .empresas-form-options label,
  .empresas-notes { grid-template-columns: 1fr; gap: 5px; }
  .empresas-identification-row { grid-template-columns: minmax(0, 1fr) 14px minmax(68px, .32fr); gap: 6px; }
  .empresas-form-field-wide { grid-column: auto; }
  .empresas-form-options { padding-left: 0; padding-right: 0; }
  .empresas-report-type { flex-wrap: wrap; gap: 8px 14px; min-width: 0; }
  .empresas-modal-footer {
    margin-left: 18px;
    margin-right: 18px;
    padding: 18px 0;
  }
  .empresas-negotiation-checks { flex-direction: column; gap: 5px; }
  .empresas-negotiation-table { margin-left: 18px; margin-right: 18px; }
}

/* Empresas en móvil: misma composición de los maestros responsive, con las
   acciones apiladas y la grilla contenida dentro de su propio scroll. */
@media (max-width: 767px) {
  body.empresas-responsive-page {
    overflow-x: hidden;
    background: #f5f7fb;
  }

  body.empresas-responsive-page .layout-wrapper,
  body.empresas-responsive-page .layout-container,
  body.empresas-responsive-page .layout-page,
  body.empresas-responsive-page .content-wrapper {
    width: 100%;
    min-width: 0;
    overflow-x: hidden;
  }

  .empresas-page .content-wrapper {
    padding-bottom: calc(78px + env(safe-area-inset-bottom));
  }

  .empresas-page .container-fluid {
    width: 100%;
    max-width: 100%;
    padding: 14px 12px calc(18px + env(safe-area-inset-bottom));
  }

  .empresas-mobile-cards {
    display: grid;
    gap: 10px;
    width: 100%;
    min-width: 0;
    margin-bottom: 14px;
  }

  .empresa-mobile-card {
    box-sizing: border-box;
    width: 100%;
    min-width: 0;
    padding: 13px;
    border: 1px solid #dbe6ef;
    border-radius: 10px;
    background: #fff;
    box-shadow: 0 3px 12px rgba(31, 55, 80, .08);
  }

  .empresa-mobile-card-header,
  .empresa-mobile-card-title,
  .empresa-mobile-card-details,
  .empresa-mobile-card-actions {
    display: flex;
    align-items: center;
  }

  .empresa-mobile-card-header {
    justify-content: space-between;
    gap: 10px;
  }

  .empresa-mobile-card-title {
    min-width: 0;
    gap: 9px;
  }

  .empresa-mobile-card-title > div {
    display: grid;
    min-width: 0;
    gap: 2px;
  }

  .empresa-mobile-card-title strong,
  .empresa-mobile-card-title span,
  .empresa-mobile-card-details span {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .empresa-mobile-card-title strong {
    color: #294b69;
    font-size: 14px;
    line-height: 1.25;
  }

  .empresa-mobile-card-title > div > span {
    color: #8192a2;
    font-size: 12px;
  }

  .empresa-mobile-card-icon {
    display: grid;
    flex: 0 0 34px;
    width: 34px;
    height: 34px;
    border-radius: 9px;
    background: #eaf3f8;
    color: #006699;
    font-size: 19px;
    place-items: center;
  }

  .empresa-mobile-card-id {
    flex: 0 0 auto;
    color: #71859a;
    font-size: 11px;
    font-weight: 700;
  }

  .empresa-mobile-card-details {
    flex-wrap: wrap;
    gap: 7px 14px;
    margin: 11px 0;
    color: #60788d;
    font-size: 12px;
  }

  .empresa-mobile-card-details > div {
    display: flex;
    min-width: 0;
    flex: 1 1 140px;
    align-items: center;
    gap: 5px;
  }

  .empresa-mobile-card-details i {
    flex: 0 0 auto;
    color: #1979a6;
    font-size: 15px;
  }

  .empresa-mobile-card-actions {
    gap: 8px;
    padding-top: 10px;
    border-top: 1px solid #edf2f6;
  }

  .empresa-mobile-action {
    box-sizing: border-box;
    display: inline-flex;
    flex: 1 1;
    min-width: 0;
    min-height: 36px;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 7px 9px;
    border: 1px solid transparent;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.1;
    white-space: nowrap;
  }

  .empresa-mobile-action-edit {
    border-color: #cbdce8;
    background: #fff;
    color: #35617d;
  }

  .empresa-mobile-action-negociaciones {
    border-color: #006699;
    background: #006699;
    color: #fff;
  }

  .empresa-mobile-action:focus-visible {
    outline: 3px solid rgba(0, 102, 153, .2);
    outline-offset: 1px;
  }

  .empresas-heading {
    display: flex;
    align-items: stretch;
    gap: 12px;
    margin: 0 0 16px;
  }

  .empresas-heading > div:first-child {
    padding: 0 4px;
  }

  .empresas-heading h4 {
    margin: 0 0 4px !important;
    color: #294b69;
    font-size: 20px;
    line-height: 1.15;
    text-align: center;
  }

  .empresas-subtitle {
    font-size: 12px;
    line-height: 1.3;
    text-align: center;
  }

  .empresas-heading-actions {
    display: grid;
    grid-template-columns: 1fr;
    width: 100%;
    gap: 10px;
  }

  .empresas-modal-variant-select,
  .empresas-heading-actions .empresas-create-button,
  .empresas-search {
    box-sizing: border-box;
    width: 100%;
    min-width: 0;
    height: 40px;
    min-height: 40px;
    margin: 0;
  }

  .empresas-modal-variant-select {
    padding: 7px 12px;
    border: 1px solid #d2dee9;
    border-radius: 7px;
    background-color: #fff;
    color: #526a83;
    font-size: 14px;
    line-height: 24px;
  }

  .empresas-heading-actions .empresas-create-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    min-height: 40px;
    height: 40px;
    padding: 0 14px;
    border-radius: 6px;
    font-size: 14px;
    line-height: 1;
    white-space: nowrap;
  }

  .empresas-search {
    border-color: #d2dee9;
    border-radius: 7px;
    display: flex;
    align-items: stretch;
  }

  .empresas-search .input-group-text {
    width: 42px;
    justify-content: center;
    padding: 0;
  }

  .empresas-search .form-control {
    box-sizing: border-box;
    min-width: 0;
    height: 38px;
    min-height: 38px;
    padding: 7px 10px;
    font-size: 14px;
    line-height: 24px;
  }

  .empresas-search .input-group-text {
    box-sizing: border-box;
    height: 38px;
    min-height: 38px;
    align-items: center;
  }

  .empresas-table-card {
    display: none;
  }

  .empresas-mobile-cards .empresas-state {
    box-sizing: border-box;
    width: 100%;
    padding: 28px 14px !important;
    border: 1px solid #dbe6ef;
    border-radius: 10px;
    background: #fff;
  }

  .empresas-table-card {
    border-radius: 10px;
    box-shadow: 0 3px 12px rgba(31, 55, 80, .08);
  }

  .empresas-table-wrapper {
    max-height: calc(100dvh - 300px);
    overflow-x: auto;
    overflow-y: auto;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
  }

  .empresas-table {
    width: max-content;
    min-width: 720px;
    table-layout: fixed;
  }

  .empresas-table thead th {
    position: sticky;
    top: 0;
    padding: 11px 14px;
    font-size: 11px;
    letter-spacing: .03em;
  }

  .empresas-table tbody td {
    max-width: 230px;
    padding: 13px 14px;
    font-size: 13px;
    line-height: 1.3;
    white-space: normal;
    overflow-wrap: anywhere;
  }

  .empresas-table th:first-child,
  .empresas-table td:first-child {
    width: 68px;
  }

  .empresas-table th:nth-child(2),
  .empresas-table td:nth-child(2) {
    width: 235px;
  }

  .empresas-table th:nth-child(3),
  .empresas-table td:nth-child(3) {
    width: 150px;
  }

  .empresas-actions-heading,
  .empresas-actions-cell {
    width: 64px;
  }

  .empresas-result-count {
    padding: 9px 12px;
    font-size: 11px;
  }

  /* Bottom sheets de Empresas: el header y el footer permanecen visibles y
     solo se desplaza el contenido del formulario. Las reglas anteriores de
     la base ocultaban este scroll con overflow:hidden. */
  .modal.empresas-base-modal .modal-dialog > .modal-content {
    display: flex;
    flex-direction: column;
    height: min(82dvh, 760px);
    max-height: min(82dvh, 760px);
    min-height: 0;
  }

  .modal.empresas-base-modal.responsive-modal-sheet-expanded
    .modal-dialog > .modal-content {
    height: 100dvh;
    max-height: 100dvh;
  }

  .modal.empresas-base-modal .modal-dialog > .modal-content > .modal-body {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    min-height: 0;
    height: auto;
    max-height: none !important;
    overflow: hidden !important;
  }

  .modal.empresas-base-modal:not(.empresas-negociaciones-base-modal)
    .empresas-modal-shell,
  .modal.empresas-base-modal:not(.empresas-negociaciones-base-modal)
    .empresas-modal-shell > form {
    flex: 1 1 auto;
    height: 100%;
    min-height: 0;
  }

  .modal.empresas-base-modal:not(.empresas-negociaciones-base-modal)
    .modal-dialog > .modal-content > .modal-body > .empresas-modal-shell {
    height: 0;
  }

  .modal.empresas-base-modal:not(.empresas-negociaciones-base-modal)
    .empresas-modal-content {
    flex: 1 1 auto;
    height: 0;
    min-height: 0;
    max-height: none !important;
    overflow-x: hidden !important;
    overflow-y: auto !important;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
  }

  .modal.empresas-base-modal:not(.empresas-negociaciones-base-modal)
    .empresas-modal-footer {
    flex: 0 0 auto;
    position: relative;
    z-index: 2;
  }

  /* Empresa fresca y compacta usan el mismo modelo de desplazamiento que
     negociaciones: un único scroll en modal-body. Esto evita que el estado
     colapsado del bottom sheet bloquee el gesto vertical. */
  .modal.empresas-base-modal:not(.empresas-negociaciones-base-modal)
    .modal-dialog > .modal-content > .modal-body {
    display: block !important;
    height: 0 !important;
    min-height: 0;
    overflow-x: hidden !important;
    overflow-y: auto !important;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
    touch-action: pan-y;
  }

  .modal.empresas-base-modal:not(.empresas-negociaciones-base-modal)
    .empresas-modal-shell,
  .modal.empresas-base-modal:not(.empresas-negociaciones-base-modal)
    .empresas-modal-shell > form {
    display: block;
    height: auto;
    min-height: 0;
    overflow: visible;
  }

  .modal.empresas-base-modal:not(.empresas-negociaciones-base-modal)
    .empresas-modal-content {
    height: auto;
    overflow: visible !important;
  }

  .modal.empresas-base-modal:not(.empresas-negociaciones-base-modal)
    .empresas-modal-footer {
    position: sticky;
    bottom: 0;
    z-index: 3;
    background: linear-gradient(180deg, rgba(248, 251, 253, .88) 0%, #f8fbfd 28%);
  }

  /* En móvil las dos variantes de empresa usan controles táctiles cómodos;
     la variante compacta conserva su layout, pero no sus inputs de 20px. */
  .modal.empresas-base-modal.empresas-compacto-modal
    .empresas-form-field input,
  .modal.empresas-base-modal.empresas-compacto-modal
    .empresas-form-field select,
  .modal.empresas-base-modal.empresas-compacto-modal
    .empresas-form-field .transportador-select__control,
  .modal.empresas-base-modal.empresas-compacto-modal
    .empresas-form-field .transportador-select__value-container,
  .modal.empresas-base-modal.empresas-compacto-modal
    .empresas-form-field .transportador-select__indicators {
    box-sizing: border-box;
    height: 38px !important;
    min-height: 38px !important;
  }

  .modal.empresas-base-modal.empresas-compacto-modal
    .empresas-form-field input,
  .modal.empresas-base-modal.empresas-compacto-modal
    .empresas-form-field select {
    padding: 7px 12px;
    border: 1px solid #cbdce8;
    border-radius: 9px;
    color: #304f6b;
    font-size: 14px;
    line-height: 1.2;
  }

  /* Negociaciones: el formulario completo es el área scrollable, no el
     modal-body bloqueado por la base. */
  .modal.empresas-negociaciones-base-modal
    .modal-dialog > .modal-content > .modal-body {
    display: block !important;
    flex: 1 1 auto;
    height: 0 !important;
    min-height: 0;
    max-height: none !important;
    overflow-x: hidden !important;
    overflow-y: auto !important;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
    touch-action: pan-y;
  }

  .modal.empresas-negociaciones-base-modal
    .empresas-negociaciones-modal.monitoreo-modern {
    display: flex;
    flex: 0 0 auto;
    height: auto !important;
    min-height: 100%;
    max-height: none;
    padding: 8px 14px calc(14px + env(safe-area-inset-bottom));
    overflow-x: hidden !important;
    overflow-y: visible !important;
    touch-action: pan-y;
  }

  .modal.empresas-negociaciones-base-modal
    .empresas-negociaciones-modal .monitoreo-form-card {
    flex: 0 0 auto;
    margin: 0;
    padding: 12px 10px;
    border: 1px solid #e0eaf3;
    border-radius: 14px;
    box-shadow: 0 4px 14px rgba(31, 55, 80, .06);
  }

  .modal.empresas-negociaciones-base-modal
    .empresas-negotiation-grid {
    gap: 9px;
  }

  .modal.empresas-negociaciones-base-modal
    .empresas-negotiation-field {
    grid-template-columns: 132px minmax(0, 1fr);
    gap: 8px;
    font-size: 12px;
  }

  .modal.empresas-negociaciones-base-modal
    .empresas-negotiation-field > span,
  .modal.empresas-negociaciones-base-modal
    .empresas-negotiation-notes > span {
    line-height: 1.2;
  }

  .modal.empresas-negociaciones-base-modal
    .empresas-negotiation-checks {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    flex: 0 0 auto;
    justify-items: start;
    gap: 10px;
    margin: 12px 0 0;
    padding: 0 4px;
  }

  .modal.empresas-negociaciones-base-modal
    .empresas-negotiation-checks .empresas-switch {
    width: 100%;
    min-height: 28px;
  }

  .modal.empresas-negociaciones-base-modal
    .empresas-negotiation-notes {
    display: grid;
    flex: 0 0 auto;
    grid-template-columns: 132px minmax(0, 1fr);
    gap: 8px;
    margin: 12px 0 0;
    padding: 0 4px !important;
  }

  .modal.empresas-negociaciones-base-modal
    .empresas-negotiation-notes .TextAreaReportSe {
    min-height: 72px;
    height: 72px;
  }

  .modal.empresas-negociaciones-base-modal
    .empresas-modal-footer {
    display: flex;
    flex: 0 0 auto;
    flex-wrap: wrap;
    gap: 8px;
    margin: 14px 4px 0;
    padding: 12px 0 calc(4px + env(safe-area-inset-bottom));
    position: sticky;
    bottom: 0;
    z-index: 3;
    background: linear-gradient(180deg, rgba(239, 245, 252, .88) 0%, #eff5fc 28%);
  }

  .modal.empresas-negociaciones-base-modal
    .empresas-modal-footer .Button {
    box-sizing: border-box;
    flex: 1 1 150px;
    min-width: 0;
    min-height: 42px;
  }

  .modal.empresas-negociaciones-base-modal
    .empresas-modal-footer .monitoreo-primary-btn {
    min-width: 0;
  }

  /* Presentación basada en el mockup móvil: bloques agrupados, título con
     contexto y controles táctiles consistentes. */
  .modal.empresas-base-modal .modal-header {
    padding: 8px 18px 12px !important;
  }

  .modal.empresas-base-modal .modal-header .modal-title {
    padding: 6px 52px 8px 18px;
  }

  .empresas-modal-heading {
    max-width: 100%;
    align-items: flex-start;
    gap: 9px;
  }

  .empresas-modal-heading > i {
    width: 30px;
    height: 30px;
    flex-basis: 30px;
    font-size: 18px;
  }

  .empresas-modal-heading strong {
    font-size: 17px;
    line-height: 1.2;
  }

  .empresas-modal-heading small {
    display: block;
    font-size: 11px;
    line-height: 1.3;
  }

  .modal.empresas-base-modal:not(.empresas-negociaciones-base-modal)
    .empresas-form-grid {
    display: grid;
    gap: 10px;
  }

  .modal.empresas-base-modal:not(.empresas-negociaciones-base-modal)
    .empresas-form-section {
    display: block;
    min-width: 0;
    padding: 10px;
    border: 1px solid #e1ebf4;
    border-radius: 15px;
    background: linear-gradient(180deg, #f5f9fd 0%, #ffffff 44%);
  }

  .modal.empresas-base-modal:not(.empresas-negociaciones-base-modal)
    .empresas-form-section-title {
    display: flex;
    align-items: center;
    gap: 7px;
    margin: 0 0 8px;
    color: #214d76;
    font-size: 13px;
    font-weight: 800;
  }

  .modal.empresas-base-modal:not(.empresas-negociaciones-base-modal)
    .empresas-form-section-title i {
    color: #0874a7;
    font-size: 17px;
  }

  .modal.empresas-base-modal:not(.empresas-negociaciones-base-modal)
    .empresas-form-section-grid {
    display: grid;
    gap: 9px;
  }

  .modal.empresas-base-modal:not(.empresas-negociaciones-base-modal)
    .empresas-form-section .empresas-identification-row {
    margin-top: 9px;
  }

  .modal.empresas-negociaciones-base-modal
    .empresas-negotiation-section-title {
    display: flex;
    align-items: center;
    gap: 7px;
    margin: 0 0 8px;
    color: #214d76;
    font-size: 13px;
    font-weight: 800;
  }

  .modal.empresas-negociaciones-base-modal
    .empresas-negotiation-section-title i {
    color: #0874a7;
    font-size: 17px;
  }

  .modal.empresas-negociaciones-base-modal
    .empresas-negotiation-main-section {
    padding: 10px;
    border: 1px solid #e1ebf4;
    border-radius: 15px;
    background: linear-gradient(180deg, #f5f9fd 0%, #ffffff 44%);
  }

  .modal.empresas-negociaciones-base-modal
    .empresas-negotiation-main-section .monitoreo-form-card {
    padding: 2px 0 0;
    border: 0;
    background: transparent;
    box-shadow: none;
  }

  .modal.empresas-negociaciones-base-modal
    .empresas-negotiation-notes {
    margin-top: 14px;
    padding: 12px 10px !important;
    border: 1px solid #e1ebf4;
    border-radius: 15px;
    background: linear-gradient(180deg, #f5f9fd 0%, #ffffff 44%);
  }

  .modal.empresas-negociaciones-base-modal
    .empresas-negotiation-checks {
    margin-top: 12px;
    padding: 10px 12px;
    border: 1px solid #e1ebf4;
    border-radius: 14px;
    background: #f5f9fd;
  }

  /* En Empresas el patrón del mockup es una hoja móvil completa. La altura
     explícita evita que el estado inicial del drag deje el modal sin área
     desplazable. */
  .modal.empresas-base-modal {
    height: 100dvh !important;
    max-height: 100dvh !important;
    min-height: 100dvh !important;
    align-items: flex-end !important;
  }

  .modal.empresas-base-modal .modal-dialog {
    height: 100dvh !important;
    max-height: 100dvh !important;
    min-height: 100dvh !important;
  }

  .modal.empresas-base-modal .modal-dialog > .modal-content {
    height: 100dvh !important;
    max-height: 100dvh !important;
    min-height: 100dvh;
    border-radius: 22px 22px 0 0;
  }

  .modal.empresas-base-modal .modal-dialog > .modal-content > .modal-header {
    flex: 0 0 auto;
  }

  .modal.empresas-base-modal .modal-dialog > .modal-content > .modal-body {
    flex: 0 0 auto !important;
    height: calc(100dvh - 92px) !important;
    max-height: calc(100dvh - 92px) !important;
    min-height: 0 !important;
    overflow-x: hidden !important;
    overflow-y: scroll !important;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior-y: contain;
    touch-action: pan-y;
  }

  .modal.empresas-base-modal .modal-header .btn-close,
  .modal.empresas-base-modal .responsive-modal-sheet-close {
    position: absolute !important;
    top: 50px !important;
    right: 16px !important;
    z-index: 1101 !important;
    display: grid !important;
    width: 38px;
    height: 38px;
    margin: 0;
    padding: 0;
    border: 0;
    border-radius: 50%;
    background-color: #edf2f8;
    background-size: 14px;
    color: #30445d;
    opacity: 1;
    pointer-events: auto;
  }

  .modal.empresas-base-modal .empresas-modal-shell,
  .modal.empresas-base-modal .empresas-modal-shell > form,
  .modal.empresas-base-modal .empresas-modal-content,
  .modal.empresas-base-modal .empresas-negociaciones-modal.monitoreo-modern {
    min-height: 0;
  }

  /* Reactstrap aplica className al modal-dialog. Estas reglas directas son
     las que gobiernan realmente el contenido de Empresas en móvil. */
  .empresas-base-modal {
    height: 100dvh !important;
    max-height: 100dvh !important;
    min-height: 100dvh !important;
  }

  .empresas-base-modal > .modal-content {
    display: flex !important;
    flex-direction: column;
    height: 100dvh !important;
    max-height: 100dvh !important;
    min-height: 100dvh;
    overflow: hidden;
    border-radius: 22px 22px 0 0;
  }

  .empresas-base-modal > .modal-content > .modal-header {
    flex: 0 0 auto;
  }

  .empresas-base-modal > .modal-content > .modal-body {
    display: flex !important;
    flex: 1 1 auto !important;
    flex-direction: column;
    height: auto !important;
    min-height: 0 !important;
    max-height: none !important;
    overflow: hidden !important;
  }

  .empresas-base-modal:not(.empresas-negociaciones-base-modal)
    > .modal-content > .modal-body {
    padding: 0 !important;
  }

  .empresas-base-modal:not(.empresas-negociaciones-base-modal)
    .empresas-modal-shell,
  .empresas-base-modal:not(.empresas-negociaciones-base-modal)
    .empresas-modal-shell > form {
    display: flex !important;
    flex: 1 1 auto;
    flex-direction: column;
    width: 100%;
    height: 100%;
    min-height: 0;
  }

  .empresas-base-modal:not(.empresas-negociaciones-base-modal)
    .empresas-modal-content {
    flex: 1 1 auto !important;
    height: 0 !important;
    min-height: 0 !important;
    max-height: none !important;
    overflow-x: hidden !important;
    overflow-y: auto !important;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
    touch-action: pan-y;
  }

  .empresas-base-modal:not(.empresas-negociaciones-base-modal)
    .empresas-modal-footer {
    position: relative !important;
    flex: 0 0 auto !important;
    bottom: auto;
    margin-top: 0;
    z-index: 2;
  }

  .empresas-base-modal.empresas-negociaciones-base-modal
    > .modal-content > .modal-body {
    display: block !important;
    flex: 0 0 auto !important;
    height: calc(100dvh - 92px) !important;
    max-height: calc(100dvh - 92px) !important;
    overflow-x: hidden !important;
    overflow-y: scroll !important;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
    touch-action: pan-y;
  }

  .empresas-base-modal.empresas-negociaciones-base-modal
    .empresas-negociaciones-modal.monitoreo-modern {
    display: flex !important;
    flex: 0 0 auto;
    height: auto !important;
    min-height: 100%;
    overflow: visible !important;
  }

  .empresas-base-modal.empresas-negociaciones-base-modal
    .empresas-modal-footer {
    position: relative !important;
    bottom: auto;
    margin-top: 14px;
  }

  /* Empresa: el footer no debe tapar campos. El formulario reproduce el
     patrón del modal de seguimiento: contenido flexible desplazable y
     acciones fuera del área de scroll. */
  .modal.empresas-base-modal:not(.empresas-negociaciones-base-modal)
    .modal-dialog > .modal-content > .modal-body {
    display: flex !important;
    flex-direction: column;
  }

  .modal.empresas-base-modal:not(.empresas-negociaciones-base-modal)
    .empresas-modal-shell {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    width: 100%;
    height: 100%;
    min-height: 0;
  }

  .modal.empresas-base-modal:not(.empresas-negociaciones-base-modal)
    .empresas-modal-shell > form {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    width: 100%;
    height: 100%;
    min-height: 0;
  }

  .modal.empresas-base-modal:not(.empresas-negociaciones-base-modal)
    .empresas-modal-content {
    flex: 1 1 auto;
    height: 0;
    min-height: 0;
    overflow-x: hidden !important;
    overflow-y: auto !important;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
  }

  .modal.empresas-base-modal:not(.empresas-negociaciones-base-modal)
    .empresas-modal-footer {
    flex: 0 0 auto;
    position: relative;
    bottom: auto;
    margin-top: 0;
  }

  /* Bottom sheet compartido: inicia parcialmente abierto y solo se vuelve
     fullscreen después del gesto de arrastre hacia arriba. */
  .modal.empresas-base-modal,
  .modal.empresas-base-modal .modal-dialog,
  .empresas-base-modal {
    height: auto !important;
    min-height: 0 !important;
    max-height: none !important;
  }

  .empresas-base-modal > .modal-content {
    height: min(82dvh, 760px) !important;
    max-height: min(82dvh, 760px) !important;
    min-height: 0 !important;
    border-radius: 22px 22px 0 0;
  }

  .modal.responsive-modal-sheet-expanded .empresas-base-modal > .modal-content {
    height: 100dvh !important;
    max-height: 100dvh !important;
    min-height: 100dvh !important;
    border-radius: 0;
  }

  .empresas-base-modal:not(.empresas-negociaciones-base-modal)
    > .modal-content > .modal-body,
  .empresas-base-modal.empresas-negociaciones-base-modal
    > .modal-content > .modal-body {
    height: calc(min(82dvh, 760px) - 92px) !important;
    max-height: calc(min(82dvh, 760px) - 92px) !important;
  }

  .modal.responsive-modal-sheet-expanded
    .empresas-base-modal:not(.empresas-negociaciones-base-modal)
    > .modal-content > .modal-body,
  .modal.responsive-modal-sheet-expanded
    .empresas-base-modal.empresas-negociaciones-base-modal
    > .modal-content > .modal-body {
    height: calc(100dvh - 92px) !important;
    max-height: calc(100dvh - 92px) !important;
  }

  .modal:not(.responsive-modal-sheet-expanded)
    .empresas-base-modal .modal-header .btn-close,
  .modal:not(.responsive-modal-sheet-expanded)
    .empresas-base-modal .responsive-modal-sheet-close {
    display: none !important;
  }

  .modal.responsive-modal-sheet-expanded
    .empresas-base-modal .modal-header .btn-close,
  .modal.responsive-modal-sheet-expanded
    .empresas-base-modal .responsive-modal-sheet-close {
    display: grid !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Css/empresas.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,0CAA0C;EAC1C,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,sCAAsC;EACtC,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,6BAA6B;EAC7B,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,aAAa;EACb,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,cAAc;EACd,aAAa;EACb,4BAA4B;EAC5B,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,gBAAgB;EAChB,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,8BAA8B,mBAAmB,EAAE;;AAEnD;;;;EAIE,oBAAoB;AACtB;;AAEA;;EAEE,aAAa;EACb,0BAA0B;EAC1B,QAAQ;AACV;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,QAAQ;AACV;;AAEA;;EAEE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;;;;EAIE,aAAa;EACb,2CAA2C;EAC3C,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,yBAAyB,cAAc,EAAE;AACzC,4BAA4B,mBAAmB,EAAE;;AAEjD,wEAAwE;AACxE;;EAEE,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8DAA8D;EAC9D,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;;EAME,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;;;;;EAKE,sBAAsB;EACtB,WAAW;EACX,oBAAoB;EACpB,eAAe;AACjB;;AAEA;;;;;iCAKiC,qBAAqB,EAAE,6CAA6C,EAAE;;AAEvG;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;AACA;qCACqC,qBAAqB,EAAE;;AAE5D;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA,+BAA+B,aAAa,EAAE,SAAS,EAAE,cAAc,EAAE,eAAe,EAAE;AAC1F,kBAAkB,4BAA4B,EAAE;AAChD,2BAA2B,gBAAgB,EAAE,gBAAgB,EAAE;AAC/D;EACE,aAAa;EACb,SAAW;EACX,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,4EAA4E;EAC5E,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA,uBAAuB,gBAAgB,EAAE,cAAc,EAAE,eAAe,EAAE;;AAE1E;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;EAGE,2BAA2B;AAC7B;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;gEACgE,UAAU,EAAE;;AAE5E;gEACgE,UAAU,EAAE;;AAE5E;gEACgE,UAAU,EAAE;;AAE5E;gEACgE,UAAU,EAAE;;AAE5E;gEACgE,UAAU,EAAE;;AAE5E;gEACgE,SAAS,EAAE;;AAE3E;;EAEE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;mEACmE;AACnE;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;;EAEE,uBAAuB;EACvB,wBAAwB;EACxB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;;EAEE,4BAA4B;EAC5B,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA,gFAAgF;AAChF;EACE,wCAAwC;EACxC,uBAAuB;EACvB,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;yEACyE;AACzE;EACE,wBAAwB;EACxB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,SAAS;EACT,YAAY;EACZ,aAAa;EACb,6DAA6D;EAC7D,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,SAAW;AACb;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;;EAGE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,aAAa;AACf;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;EAGE,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,2CAA2C;EAC3C,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;wDACwD;AACxD;EACE,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,2CAA2C;EAC3C,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;EAIE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oFAAoF;AACtF;;AAEA;;;;EAIE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;6EAC6E;AAC7E;EACE,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gDAAgD;EAChD,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,2CAA2C;EAC3C,QAAQ;AACV;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;EAGE,YAAY;EACZ,WAAW;AACb;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;0EAC0E;AAC1E;EACE,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,QAAQ;AACV;;AAEA;EACE,2CAA2C;EAC3C,QAAQ;EACR,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;;;EAIE,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,iCAAiC;EACjC,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;;EAEE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,wBAAwB;EACxB,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;;EAEE,2BAA2B;EAC3B,0BAA0B;EAC1B,wBAAwB;EACxB,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,wBAAwB;EACxB,8BAA8B;EAC9B,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,8DAA8D;EAC9D,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,kCAAkC;IAClC,wCAAwC;IACxC,iCAAiC;IACjC,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,uBAAuB;IACvB,uBAAuB;IACvB,mBAAmB;IACnB,4BAA4B;EAC9B;AACF;;AAEA;EACE;wDACsD;EACtD;IACE,wBAAwB;IACxB,sBAAsB;IACtB,oBAAoB;IACpB,YAAY;IACZ,gBAAgB;IAChB,8BAA8B;IAC9B,oBAAoB;EACtB;;EAEA;IACE,6BAA6B;IAC7B,oBAAoB;IACpB,sBAAsB;IACtB,wBAAwB;IACxB,wBAAwB;IACxB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;IACrB,UAAU;IACV,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,6BAA6B;EAC/B;;EAEA;IACE,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;qEACmE;EACnE;;IAEE,6BAA6B;IAC7B,oBAAoB;IACpB,sBAAsB;IACtB,wBAAwB;IACxB,wBAAwB;IACxB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;IACrB,UAAU;EACZ;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;;EAEA;IACE,wDAAwD;EAC1D;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,+BAA+B;IAC/B,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA,0BAA0B,WAAW,EAAE;;EAEvC;IACE,6BAA6B;IAC7B,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,YAAY;EACd;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,4BAA4B;EAC9B;;EAEA,yBAAyB,uBAAuB,EAAE;EAClD,4BAA4B,eAAe,EAAE;EAC7C,6EAA6E,aAAa,EAAE;EAC5F,uFAAuF,aAAa,EAAE;EACtG,oFAAoF,0BAA0B,EAAE,QAAQ,EAAE;EAC1H,sFAAsF,uBAAuB,EAAE;EAC/G;IACE,0BAA0B;IAC1B,aAAa;EACf;EACA;IACE,0BAA0B;IAC1B,QAAQ;EACV;EACA;IACE,aAAa;EACf;EACA;;;oDAGkD,kBAAkB,EAAE,mBAAmB,EAAE;EAC3F,0BAA0B,kBAAkB,EAAE,mBAAmB,EAAE;EACnE;+BAC6B,0BAA0B,EAAE,SAAS,EAAE;EACpE;;;oBAGkB,0BAA0B,EAAE,QAAQ,EAAE;EACxD,+BAA+B,8DAA8D,EAAE,QAAQ,EAAE;EACzG,4BAA4B,iBAAiB,EAAE;EAC/C,yBAAyB,eAAe,EAAE,gBAAgB,EAAE;EAC5D,wBAAwB,eAAe,EAAE,aAAa,EAAE,YAAY,EAAE;EACtE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;EACjB;EACA,+BAA+B,sBAAsB,EAAE,QAAQ,EAAE;EACjE,8BAA8B,iBAAiB,EAAE,kBAAkB,EAAE;AACvE;;AAEA;wEACwE;AACxE;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;;;;IAIE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,wDAAwD;EAC1D;;EAEA;IACE,WAAW;IACX,eAAe;IACf,2DAA2D;EAC7D;;EAEA;IACE,aAAa;IACb,SAAS;IACT,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,4CAA4C;EAC9C;;EAEA;;;;IAIE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,QAAQ;EACV;;EAEA;;;IAGE,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,aAAa;IACb,cAAc;IACd,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,cAAc;IACd,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,iBAAiB;IACjB,6BAA6B;EAC/B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;IAChB,6BAA6B;IAC7B,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;IACrB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,qBAAqB;IACrB,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,wCAAwC;IACxC,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,oBAAoB;IACpB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,0BAA0B;IAC1B,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,0BAA0B;IAC1B,WAAW;IACX,SAAS;EACX;;EAEA;;;IAGE,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;IACd,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;IACrB,kBAAkB;IAClB,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,UAAU;EACZ;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,6BAA6B;IAC7B,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,4CAA4C;EAC9C;;EAEA;IACE,gCAAgC;IAChC,gBAAgB;IAChB,gBAAgB;IAChB,4BAA4B;IAC5B,iCAAiC;EACnC;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,MAAM;IACN,kBAAkB;IAClB,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;;IAEE,WAAW;EACb;;EAEA;;IAEE,YAAY;EACd;;EAEA;;IAEE,YAAY;EACd;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;;yDAEuD;EACvD;IACE,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,6BAA6B;IAC7B,aAAa;EACf;;EAEA;;IAEE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,cAAc;IACd,sBAAsB;IACtB,aAAa;IACb,YAAY;IACZ,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA;;;;IAIE,cAAc;IACd,YAAY;IACZ,aAAa;EACf;;EAEA;;IAEE,SAAS;EACX;;EAEA;;IAEE,cAAc;IACd,SAAS;IACT,aAAa;IACb,2BAA2B;IAC3B,6BAA6B;IAC7B,2BAA2B;IAC3B,iCAAiC;IACjC,4BAA4B;EAC9B;;EAEA;;IAEE,cAAc;IACd,kBAAkB;IAClB,UAAU;EACZ;;EAEA;;4DAE0D;EAC1D;;IAEE,yBAAyB;IACzB,oBAAoB;IACpB,aAAa;IACb,6BAA6B;IAC7B,2BAA2B;IAC3B,iCAAiC;IACjC,4BAA4B;IAC5B,mBAAmB;EACrB;;EAEA;;;;IAIE,cAAc;IACd,YAAY;IACZ,aAAa;IACb,iBAAiB;EACnB;;EAEA;;IAEE,YAAY;IACZ,4BAA4B;EAC9B;;EAEA;;IAEE,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,6EAA6E;EAC/E;;EAEA;2EACyE;EACzE;;;;;;;;;;IAUE,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;;;;IAIE,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;wCACsC;EACtC;;IAEE,yBAAyB;IACzB,cAAc;IACd,oBAAoB;IACpB,aAAa;IACb,2BAA2B;IAC3B,6BAA6B;IAC7B,2BAA2B;IAC3B,iCAAiC;IACjC,4BAA4B;IAC5B,mBAAmB;EACrB;;EAEA;;IAEE,aAAa;IACb,cAAc;IACd,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,0DAA0D;IAC1D,6BAA6B;IAC7B,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;;IAEE,cAAc;IACd,SAAS;IACT,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,4CAA4C;EAC9C;;EAEA;;IAEE,QAAQ;EACV;;EAEA;;IAEE,2CAA2C;IAC3C,QAAQ;IACR,eAAe;EACjB;;EAEA;;;;IAIE,gBAAgB;EAClB;;EAEA;;IAEE,aAAa;IACb,qCAAqC;IACrC,cAAc;IACd,oBAAoB;IACpB,SAAS;IACT,gBAAgB;IAChB,cAAc;EAChB;;EAEA;;IAEE,WAAW;IACX,gBAAgB;EAClB;;EAEA;;IAEE,aAAa;IACb,cAAc;IACd,2CAA2C;IAC3C,QAAQ;IACR,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;;IAEE,gBAAgB;IAChB,YAAY;EACd;;EAEA;;IAEE,aAAa;IACb,cAAc;IACd,eAAe;IACf,QAAQ;IACR,kBAAkB;IAClB,uDAAuD;IACvD,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,6EAA6E;EAC/E;;EAEA;;IAEE,sBAAsB;IACtB,eAAe;IACf,YAAY;IACZ,gBAAgB;EAClB;;EAEA;;IAEE,YAAY;EACd;;EAEA;kDACgD;EAChD;IACE,iCAAiC;EACnC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;;IAEE,aAAa;IACb,SAAS;EACX;;EAEA;;IAEE,cAAc;IACd,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,4DAA4D;EAC9D;;EAEA;;IAEE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;;IAEE,cAAc;IACd,eAAe;EACjB;;EAEA;;IAEE,aAAa;IACb,QAAQ;EACV;;EAEA;;IAEE,eAAe;EACjB;;EAEA;;IAEE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;;IAEE,cAAc;IACd,eAAe;EACjB;;EAEA;;IAEE,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,4DAA4D;EAC9D;;EAEA;;IAEE,gBAAgB;IAChB,SAAS;IACT,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;;IAEE,gBAAgB;IAChB,6BAA6B;IAC7B,yBAAyB;IACzB,mBAAmB;IACnB,4DAA4D;EAC9D;;EAEA;;IAEE,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;;mBAEiB;EACjB;IACE,yBAAyB;IACzB,6BAA6B;IAC7B,6BAA6B;IAC7B,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;IACzB,6BAA6B;IAC7B,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,sCAAsC;IACtC,0CAA0C;IAC1C,wBAAwB;IACxB,6BAA6B;IAC7B,6BAA6B;IAC7B,iCAAiC;IACjC,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;;IAEE,6BAA6B;IAC7B,oBAAoB;IACpB,sBAAsB;IACtB,wBAAwB;IACxB,wBAAwB;IACxB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;IACd,UAAU;IACV,oBAAoB;EACtB;;EAEA;;;;IAIE,aAAa;EACf;;EAEA;qEACmE;EACnE;IACE,yBAAyB;IACzB,6BAA6B;IAC7B,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;IACxB,sBAAsB;IACtB,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;EAC9B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,wBAAwB;IACxB,yBAAyB;IACzB,sBAAsB;IACtB,uBAAuB;IACvB,wBAAwB;IACxB,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA;;IAEE,qBAAqB;EACvB;;EAEA;;;;IAIE,wBAAwB;IACxB,cAAc;IACd,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,aAAa;EACf;;EAEA;;IAEE,yBAAyB;IACzB,oBAAoB;IACpB,wBAAwB;IACxB,2BAA2B;IAC3B,6BAA6B;IAC7B,2BAA2B;IAC3B,iCAAiC;IACjC,4BAA4B;IAC5B,mBAAmB;EACrB;;EAEA;;IAEE,6BAA6B;IAC7B,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,UAAU;EACZ;;EAEA;;IAEE,yBAAyB;IACzB,yBAAyB;IACzB,sCAAsC;IACtC,0CAA0C;IAC1C,6BAA6B;IAC7B,6BAA6B;IAC7B,iCAAiC;IACjC,4BAA4B;IAC5B,mBAAmB;EACrB;;EAEA;;IAEE,wBAAwB;IACxB,cAAc;IACd,uBAAuB;IACvB,gBAAgB;IAChB,4BAA4B;EAC9B;;EAEA;;IAEE,6BAA6B;IAC7B,YAAY;IACZ,gBAAgB;EAClB;;EAEA;;yCAEuC;EACvC;;IAEE,wBAAwB;IACxB,sBAAsB;EACxB;;EAEA;;IAEE,aAAa;IACb,cAAc;IACd,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,aAAa;EACf;;EAEA;;IAEE,aAAa;IACb,cAAc;IACd,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,aAAa;EACf;;EAEA;;IAEE,cAAc;IACd,SAAS;IACT,aAAa;IACb,6BAA6B;IAC7B,2BAA2B;IAC3B,iCAAiC;IACjC,4BAA4B;EAC9B;;EAEA;;IAEE,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,aAAa;EACf;;EAEA;6DAC2D;EAC3D;;;IAGE,uBAAuB;IACvB,wBAAwB;IACxB,2BAA2B;EAC7B;;EAEA;IACE,oCAAoC;IACpC,wCAAwC;IACxC,wBAAwB;IACxB,4BAA4B;EAC9B;;EAEA;IACE,yBAAyB;IACzB,6BAA6B;IAC7B,6BAA6B;IAC7B,gBAAgB;EAClB;;EAEA;;;;IAIE,iDAAiD;IACjD,qDAAqD;EACvD;;EAEA;;;;;;IAME,sCAAsC;IACtC,0CAA0C;EAC5C;;EAEA;;;;IAIE,wBAAwB;EAC1B;;EAEA;;;;IAIE,wBAAwB;EAC1B;AACF","sourcesContent":[".empresas-page {\n  min-height: 100vh;\n  background: #f5f7fb;\n}\n\n.empresas-heading {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 20px;\n  margin-bottom: 18px;\n}\n\n.empresas-heading-actions {\n  --empresas-control-height: 38px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.empresas-primary-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  border: 0;\n  padding: 10px 20px;\n  border-radius: 5px;\n  background: #006699;\n  color: #fff;\n  font-weight: 600;\n}\n\n.empresas-primary-button:hover,\n.empresas-primary-button:focus {\n  background: #00527a;\n  color: #fff;\n}\n\n.empresas-heading-actions .empresas-create-button {\n  height: var(--empresas-control-height);\n  min-height: var(--empresas-control-height);\n  padding-block: 0;\n  white-space: nowrap;\n}\n\n.empresas-heading h4 {\n  color: #263b50;\n}\n\n.empresas-subtitle {\n  margin: 0;\n  color: #71859a;\n  font-size: 13px;\n}\n\n.empresas-search {\n  width: min(340px, 100%);\n  height: var(--empresas-control-height);\n  border: 1px solid #cbd5df;\n  border-radius: 8px;\n  overflow: hidden;\n  background: #fff;\n}\n\n.empresas-search .input-group-text {\n  border: 0;\n  border-right: 1px solid #e1e8ef;\n  background: #fff;\n  color: #71879b;\n}\n\n.empresas-search .form-control {\n  border: 0;\n  box-shadow: none;\n}\n\n.empresas-table-card {\n  overflow: hidden;\n  border: 0;\n  border-radius: 12px;\n  box-shadow: 0 4px 18px rgba(31, 55, 80, .08);\n}\n\n.empresas-table-wrapper {\n  max-height: calc(100vh - 230px);\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.empresas-table {\n  min-width: 520px;\n  margin: 0;\n}\n\n.empresas-table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  padding: 13px 18px;\n  white-space: nowrap;\n  background: #006699 !important;\n  color: #fff !important;\n  font-size: 12px;\n  letter-spacing: .04em;\n}\n\n.empresas-table tbody td {\n  padding: 14px 18px;\n  vertical-align: middle;\n  color: #536b83;\n}\n\n.empresas-table tbody td:first-child {\n  width: 110px;\n  color: #49647e;\n}\n\n.empresas-table tbody tr:hover {\n  background: #f1f7fb;\n}\n\n.empresas-actions-heading,\n.empresas-actions-cell {\n  width: 88px;\n  text-align: center;\n}\n\n.empresas-actions-heading {\n  font-size: 0 !important;\n}\n\n.empresas-actions-cell {\n  position: relative;\n}\n\n.empresas-row-menu {\n  position: relative;\n  display: inline-block;\n}\n\n.empresas-dots-button {\n  width: 32px;\n  height: 32px;\n  border: 0;\n  border-radius: 50%;\n  background: transparent;\n  color: #006699;\n}\n\n.empresas-dots-button:hover,\n.empresas-dots-button:focus {\n  background: #eaf3f8;\n  outline: none;\n}\n\n.empresas-dropdown {\n  position: fixed;\n  z-index: 1200;\n  min-width: 170px;\n  max-width: calc(100vw - 24px);\n  padding: 6px;\n  border: 1px solid #dce6ee;\n  border-radius: 8px;\n  background: #fff;\n  box-shadow: 0 8px 22px rgba(32, 59, 83, .18);\n  text-align: left;\n}\n\n.empresas-modal-backdrop {\n  position: fixed;\n  z-index: 1100;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: rgba(27, 43, 57, .55);\n}\n\n.empresas-base-modal .modal-body {\n  padding: 0;\n  display: flex;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.empresas-base-modal .modal-content {\n  display: flex;\n  flex-direction: column;\n  max-height: min(850px, 92vh);\n}\n\n.empresas-base-modal .modal-header {\n  flex: 0 0 auto;\n}\n\n.empresas-base-modal .modal-body {\n  flex: 1 1 auto;\n}\n\n.empresas-modal-shell {\n  display: flex;\n  flex: 1 1 auto;\n  min-height: 0;\n  width: 100%;\n}\n\n.empresas-modal-shell > form {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  min-height: 0;\n  width: 100%;\n}\n\n.empresas-modal-content {\n  flex: 1 1 auto;\n  min-height: 0;\n  max-height: min(780px, 82vh);\n  padding: 12px 18px 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  background: #fff;\n}\n\n.empresas-modal {\n  width: min(900px, 100%);\n  max-height: min(850px, 92vh);\n  overflow-y: auto;\n  border: 1px solid rgba(67, 89, 113, .2);\n  border-radius: 14px;\n  background: #fff;\n  box-shadow: 0 16px 48px rgba(13, 43, 66, .3);\n}\n\n.empresas-modal-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 22px 26px 16px;\n  border-bottom: 1px solid #e8eef3;\n}\n\n.empresas-modal-kicker {\n  display: block;\n  margin-bottom: 5px;\n  color: #08719f;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: .08em;\n  text-transform: uppercase;\n}\n\n.empresas-modal-header h5 {\n  margin: 0;\n  color: #263b50;\n  font-size: 21px;\n}\n\n.empresas-modal-close {\n  width: 34px;\n  height: 34px;\n  border: 0;\n  border-radius: 50%;\n  background: #eef4f8;\n  color: #526d84;\n}\n\n.empresas-modal-close:hover { background: #dfeaf1; }\n\n.empresas-modal-content form,\n.empresas-negociaciones-modal > .empresas-negotiation-grid,\n.empresas-negociaciones-modal > .empresas-negotiation-checks,\n.empresas-negociaciones-modal > .empresas-notes {\n  padding: 12px 18px 0;\n}\n\n.empresas-form-grid,\n.empresas-negotiation-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 7px;\n}\n\n.empresas-form-section,\n.empresas-form-section-grid {\n  display: contents;\n}\n\n.empresas-form-section-title {\n  display: none;\n}\n\n.empresas-modal-heading {\n  display: inline-flex;\n  min-width: 0;\n  align-items: center;\n  gap: 10px;\n}\n\n.empresas-modal-heading > i {\n  display: grid;\n  width: 32px;\n  height: 32px;\n  flex: 0 0 32px;\n  place-items: center;\n  border-radius: 9px;\n  background: #eaf3f9;\n  color: #0874a7;\n  font-size: 20px;\n}\n\n.empresas-modal-heading > span {\n  display: grid;\n  min-width: 0;\n  gap: 2px;\n}\n\n.empresas-modal-heading strong,\n.empresas-modal-heading small {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.empresas-modal-heading strong {\n  color: #294b69;\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.empresas-modal-heading small {\n  color: #8195a8;\n  font-size: 11px;\n  font-weight: 500;\n}\n\n.empresas-negotiation-section {\n  min-width: 0;\n}\n\n.empresas-negotiation-section-title {\n  display: none;\n}\n\n.empresas-form-field,\n.empresas-negotiation-grid label,\n.empresas-form-options label,\n.empresas-notes {\n  display: grid;\n  grid-template-columns: 145px minmax(0, 1fr);\n  align-items: center;\n  gap: 7px;\n  color: #425d75;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.empresas-form-field b { color: #c14848; }\n.empresas-form-field-wide { grid-column: 1 / -1; }\n\n/* Misma base visual de los formularios de actualización de contratos. */\n.empresas-base-modal .empresas-form-field > .Label,\n.empresas-base-modal .empresas-form-options > label > .Label {\n  margin: 0;\n  color: #000;\n  font-size: 15px;\n  font-weight: 700;\n}\n\n.empresas-base-modal .Input,\n.empresas-base-modal .InputSelect {\n  width: 100%;\n  min-height: 20px;\n  height: 20px;\n  box-sizing: border-box;\n  padding: 0 10px;\n  border: 1px solid #000;\n  border-radius: 4px;\n  background: #fff;\n  color: #000;\n  font-size: 15px;\n  line-height: 1;\n  box-shadow: none;\n}\n\n.empresas-base-modal .Input:focus,\n.empresas-base-modal .InputSelect:focus {\n  border-color: #000;\n  box-shadow: none;\n}\n\n.empresas-identification-row {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 18px minmax(90px, .32fr);\n  grid-column: 1 / -1;\n  order: 5;\n  align-items: end;\n  gap: 10px;\n}\n\n.empresas-form-grid > .empresas-form-field:nth-child(n + 6) {\n  order: 6;\n}\n\n.empresas-identification-separator {\n  padding-bottom: 6px;\n  color: #425d75;\n  font-size: 16px;\n  text-align: center;\n}\n\n.empresas-verification-field {\n  display: block;\n}\n\n.empresas-form-field input,\n.empresas-form-field select,\n.empresas-negotiation-grid input,\n.empresas-negotiation-grid select,\n.empresas-form-options select,\n.empresas-notes textarea {\n  min-height: 32px;\n  padding: 5px 8px;\n  border: 1px solid #cbd8e2;\n  border-radius: 6px;\n  background: #fff;\n  color: #334f68;\n  outline: none;\n}\n\n.empresas-form-field input,\n.empresas-form-field select,\n.empresas-negotiation-grid input,\n.empresas-negotiation-grid select,\n.empresas-form-options select {\n  box-sizing: border-box;\n  width: 100%;\n  font-family: inherit;\n  font-size: 13px;\n}\n\n.empresas-form-field input:focus,\n.empresas-form-field select:focus,\n.empresas-negotiation-grid input:focus,\n.empresas-negotiation-grid select:focus,\n.empresas-form-options select:focus,\n.empresas-notes textarea:focus { border-color: #1683b5; box-shadow: 0 0 0 3px rgba(22, 131, 181, .12); }\n\n.empresas-form-field select:disabled {\n  cursor: not-allowed;\n  background-color: #f1f4f7;\n  color: #526b82;\n  opacity: 1;\n}\n\n.empresas-form-options {\n  display: flex;\n  align-items: flex-end;\n  gap: 25px;\n  padding: 12px 0 0;\n}\n\n.empresas-report-type {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  min-width: 260px;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  color: #425d75;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.empresas-report-type legend {\n  float: left;\n  width: auto;\n  margin: 0 14px 0 0;\n  color: #425d75;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.empresas-report-type label {\n  display: inline-flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 5px;\n  min-height: 38px;\n  color: #425d75;\n  font-size: 13px;\n  font-weight: 400;\n}\n\n.empresas-report-type input {\n  accent-color: #006699;\n}\n\n.empresas-check,\n.empresas-negotiation-checks label {\n  display: flex !important;\n  flex-direction: row !important;\n  align-items: center;\n  min-height: 38px;\n}\n.empresas-check input,\n.empresas-negotiation-checks input { accent-color: #0875aa; }\n\n.empresas-switch {\n  display: inline-flex !important;\n  flex-direction: row !important;\n  align-items: center;\n  gap: 8px !important;\n  min-height: 38px;\n  color: #425d75;\n  cursor: pointer;\n}\n\n.empresas-switch input {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  opacity: 0;\n}\n\n.empresas-switch-track {\n  position: relative;\n  display: inline-flex;\n  width: 38px;\n  height: 21px;\n  flex: 0 0 auto;\n  border-radius: 20px;\n  background: #b9c6d0;\n  transition: background .2s ease;\n}\n\n.empresas-switch-thumb {\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  width: 15px;\n  height: 15px;\n  border-radius: 50%;\n  background: #fff;\n  box-shadow: 0 1px 3px rgba(20, 45, 64, .25);\n  transition: transform .2s ease;\n}\n\n.empresas-switch input:checked + .empresas-switch-track {\n  background: #006699;\n}\n\n.empresas-switch input:checked + .empresas-switch-track .empresas-switch-thumb {\n  transform: translateX(17px);\n}\n\n.empresas-modal-footer {\n  flex: 0 0 auto;\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 14px 18px;\n  border-top: 1px solid #e8eef3;\n  margin-top: 14px;\n}\n\n.empresas-negotiation-checks { display: flex; gap: 24px; color: #425d75; font-size: 13px; }\n.empresas-notes { padding-bottom: 0 !important; }\n.empresas-notes textarea { min-height: 84px; resize: vertical; }\n.empresas-negotiation-table {\n  display: flex;\n  flex: 1 1 0;\n  flex-direction: column;\n  min-height: 0;\n  height: auto;\n  max-height: none;\n  /* El espacio inferior no debe consumir la altura disponible de la grilla. */\n  margin: 0 26px 20px;\n  padding-bottom: 0;\n  padding-top: 0;\n  background: #fff;\n  color: #425d75;\n  font-size: 13px;\n  overflow: hidden;\n}\n.empresas-empty-mini { margin-top: 10px; color: #8092a3; font-size: 12px; }\n\n.empresas-negotiation-results {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  min-height: 0;\n  height: auto !important;\n  max-height: none;\n  width: 100%;\n  max-width: 100%;\n  margin-top: 0;\n  background: #fff;\n  overflow-x: hidden;\n  overflow-y: auto;\n  scrollbar-width: thin;\n}\n\n.empresas-negotiation-results .empresas-table tbody {\n  display: table-row-group !important;\n  visibility: visible !important;\n}\n\n.empresas-negotiation-results .empresas-table tbody tr {\n  display: table-row !important;\n  visibility: visible !important;\n}\n\n.empresas-negotiation-results thead th {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\n.empresas-negotiation-results .empresas-table {\n  width: 100%;\n  min-width: 0;\n  table-layout: fixed;\n  margin-bottom: 0;\n  background: #fff;\n}\n\n.empresas-negotiation-results .empresas-table tbody,\n.empresas-negotiation-results .empresas-table tbody tr,\n.empresas-negotiation-results .empresas-table tbody td {\n  background: #fff !important;\n}\n\n.empresas-negotiation-results .empresas-table th,\n.empresas-negotiation-results .empresas-table td {\n  overflow: hidden;\n  padding: 10px 8px;\n  text-overflow: ellipsis;\n  vertical-align: middle;\n}\n\n.empresas-negotiation-results .empresas-table th:nth-child(1),\n.empresas-negotiation-results .empresas-table td:nth-child(1) { width: 27%; }\n\n.empresas-negotiation-results .empresas-table th:nth-child(2),\n.empresas-negotiation-results .empresas-table td:nth-child(2) { width: 16%; }\n\n.empresas-negotiation-results .empresas-table th:nth-child(3),\n.empresas-negotiation-results .empresas-table td:nth-child(3) { width: 17%; }\n\n.empresas-negotiation-results .empresas-table th:nth-child(4),\n.empresas-negotiation-results .empresas-table td:nth-child(4) { width: 12%; }\n\n.empresas-negotiation-results .empresas-table th:nth-child(5),\n.empresas-negotiation-results .empresas-table td:nth-child(5) { width: 13%; }\n\n.empresas-negotiation-results .empresas-table th:nth-child(6),\n.empresas-negotiation-results .empresas-table td:nth-child(6) { width: 8%; }\n\n.empresas-negotiation-results .empresas-table th:nth-child(1),\n.empresas-negotiation-results .empresas-table td:nth-child(1) {\n  white-space: normal;\n  word-break: break-word;\n}\n\n.empresas-negotiation-results .empresas-table th {\n  color: #fff;\n}\n\n.empresas-negotiation-actions-heading,\n.empresas-negotiation-actions-cell {\n  width: 48px;\n  text-align: center;\n}\n\n.empresas-negotiation-actions-cell button {\n  padding: 2px 6px;\n  border: 0;\n  background: transparent;\n  color: #006699;\n  font-size: 20px;\n  line-height: 1;\n}\n\n.empresas-negociaciones-modal .empresas-negotiation-switches {\n  align-items: center;\n  min-height: 32px;\n}\n\n.empresas-negociaciones-modal .empresas-switch {\n  min-height: 28px;\n  gap: 7px !important;\n  color: #425d75;\n  font-size: 13px;\n}\n\n.empresas-negociaciones-modal .empresas-switch-track {\n  width: 36px;\n  height: 20px;\n}\n\n.empresas-negociaciones-modal .empresas-switch-thumb {\n  width: 14px;\n  height: 14px;\n}\n\n.empresas-negociaciones-modal .empresas-switch input:checked + .empresas-switch-track .empresas-switch-thumb {\n  transform: translateX(16px);\n}\n\n/* react-select tiene un input interno para la búsqueda. Las reglas\n   generales del formulario no deben aplicarle la altura de 32px. */\n.empresas-base-modal .empresas-form-field .transportador-select__control {\n  min-height: 38px !important;\n  height: 38px !important;\n  border: 1px solid #cbdce8 !important;\n  border-radius: 9px !important;\n}\n\n.empresas-base-modal .empresas-form-field .transportador-select__value-container {\n  height: 36px !important;\n  min-height: 36px !important;\n  padding: 0 10px !important;\n  overflow: hidden;\n}\n\n.empresas-base-modal .empresas-form-field .transportador-select__input-container,\n.empresas-base-modal .empresas-form-field .transportador-select__input {\n  height: 36px !important;\n  min-height: 0 !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  line-height: 36px !important;\n}\n\n.empresas-base-modal .empresas-form-field .transportador-select__single-value,\n.empresas-base-modal .empresas-form-field .transportador-select__placeholder {\n  line-height: 36px !important;\n  margin: 0 !important;\n  white-space: nowrap;\n}\n\n.empresas-base-modal .empresas-form-field .transportador-select__indicators,\n.empresas-base-modal .empresas-form-field .transportador-select__indicators-container {\n  height: 36px !important;\n}\n\n/* Estructura del formulario de negociaciones basada en el modal de monitoreo. */\n.empresas-negociaciones-modal.monitoreo-modern {\n  --empresas-negotiation-bottom-space: 20%;\n  height: 100% !important;\n  min-height: 0;\n  width: 100%;\n  box-sizing: border-box;\n  padding: 10px 18px 18px;\n  background: transparent;\n  overflow-x: hidden;\n  overflow-y: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n/* El modal de negociaciones comparte la misma base visual del modal de\n   monitoreo: encabezado limpio, fondo suave y contenido sin desbordes. */\n.empresas-negociaciones-base-modal .modal-content {\n  height: min(850px, 92vh);\n  border: 0;\n  border-radius: 18px;\n  overflow: hidden;\n  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.26);\n}\n\n.empresas-negociaciones-base-modal .modal-header {\n  padding: 16px 24px 12px;\n  border-bottom: 0;\n  background: #fff;\n  color: #0f172a;\n}\n\n.empresas-negociaciones-base-modal .modal-header .modal-title {\n  color: #526a83;\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 1.3;\n}\n\n.empresas-negociaciones-base-modal .modal-body {\n  display: flex;\n  flex: 1 1 auto;\n  height: 0;\n  min-width: 0;\n  min-height: 0;\n  background: linear-gradient(180deg, #f7fbff 0%, #eff5fc 100%);\n  overflow: hidden !important;\n}\n\n.empresas-negociaciones-modal .monitoreo-form-card {\n  margin: 0;\n  padding: 10px 8px;\n  border-radius: 12px;\n  background: #f9fcff;\n}\n\n.empresas-negociaciones-modal .empresas-negotiation-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n}\n\n.empresas-negociaciones-modal .empresas-negotiation-field {\n  display: grid;\n  grid-template-columns: 145px minmax(0, 1fr);\n  align-items: center;\n  gap: 7px;\n  width: 100%;\n  margin: 0;\n  color: #000;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.empresas-time-range {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.empresas-time-range .Input {\n  min-width: 0;\n  flex: 1 1 0;\n}\n\n.empresas-time-range > span {\n  flex: 0 0 auto;\n  color: #526a83;\n  font-weight: 600;\n}\n\n.empresas-negociaciones-modal .empresas-negotiation-field > span,\n.empresas-negociaciones-modal .empresas-notes > span {\n  align-self: center;\n}\n\n.empresas-negociaciones-modal .Input,\n.empresas-negociaciones-modal .InputSelectReportSeguimihnetoSol,\n.empresas-negociaciones-modal .TextAreaReportSe {\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n  border: 1px solid #cfe0f0;\n  border-radius: 10px;\n  background: #fff;\n  color: #334f68;\n  font-family: inherit;\n  font-size: 13px;\n  outline: none;\n}\n\n.empresas-negociaciones-modal .Input,\n.empresas-negociaciones-modal .InputSelectReportSeguimihnetoSol {\n  height: 32px;\n  min-height: 32px;\n  margin: 0;\n  padding: 5px 10px;\n  box-shadow: none;\n}\n\n.empresas-negociaciones-modal .TextAreaReportSe {\n  min-height: 64px;\n  height: 64px;\n  padding: 8px 10px;\n  resize: vertical;\n  box-shadow: none;\n}\n\n.empresas-negociaciones-modal .Input:focus,\n.empresas-negociaciones-modal .InputSelectReportSeguimihnetoSol:focus,\n.empresas-negociaciones-modal .TextAreaReportSe:focus {\n  border-color: #86b7fe;\n  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.12);\n}\n\n.empresas-negociaciones-modal .empresas-negotiation-checks {\n  margin: 8px 0 0;\n  padding: 0 8px;\n  gap: 24px;\n  color: #425d75;\n  font-size: 13px;\n}\n\n.empresas-negociaciones-modal .empresas-negotiation-notes {\n  grid-template-columns: 145px minmax(0, 1fr);\n  margin: 8px 0 0;\n  padding: 0 8px !important;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.empresas-negociaciones-modal .empresas-modal-footer {\n  margin-top: 12px;\n  margin-left: 26px;\n  margin-right: 26px;\n  padding: 14px 0;\n}\n\n.empresas-negociaciones-modal .empresas-modal-footer .Button {\n  min-width: 120px;\n  margin: 0;\n}\n\n.empresas-negociaciones-modal .empresas-modal-footer .btn-light {\n  color: #425d75;\n  background: #fff;\n  border: 0;\n}\n\n.empresas-negociaciones-modal .empresas-modal-footer .monitoreo-primary-btn {\n  min-width: 190px;\n  border-radius: 10px !important;\n}\n\n.empresas-state {\n  padding: 42px 20px !important;\n  color: #71859a !important;\n  text-align: center;\n}\n\n.empresas-state-error {\n  color: #b44c4c !important;\n}\n\n.empresas-result-count {\n  padding: 9px 18px;\n  border-top: 1px solid #edf2f6;\n  color: #8092a3;\n  font-size: 12px;\n  text-align: right;\n}\n\n/* Presentación moderna del formulario de empresa. El modal de negociaciones\n   conserva su propia densidad y estilos de monitoreo. */\n.empresas-base-modal:not(.empresas-negociaciones-base-modal) .modal-dialog {\n  width: min(760px, calc(100vw - 32px));\n  max-width: 760px;\n}\n\n.empresas-base-modal:not(.empresas-negociaciones-base-modal) .modal-content {\n  overflow: hidden;\n  border: 1px solid #dbe7ef;\n  border-radius: 8px;\n  background: #fff;\n  box-shadow: 0 10px 26px rgba(31, 55, 80, .18);\n}\n\n.empresas-base-modal:not(.empresas-negociaciones-base-modal) .modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 22px 24px 16px;\n  border-bottom: 0;\n  background: #fff;\n}\n\n.empresas-base-modal:not(.empresas-negociaciones-base-modal) .modal-header h5 {\n  color: #526a83;\n  font-size: 20px;\n  font-weight: 500;\n}\n\n.empresas-base-modal:not(.empresas-negociaciones-base-modal) .modal-body,\n.empresas-base-modal:not(.empresas-negociaciones-base-modal) .empresas-modal-content {\n  background: #fff;\n}\n\n.empresas-base-modal:not(.empresas-negociaciones-base-modal) .empresas-modal-content {\n  padding: 20px 26px 4px;\n}\n\n.empresas-base-modal:not(.empresas-negociaciones-base-modal) .empresas-form-grid {\n  gap: 11px;\n}\n\n.empresas-base-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field {\n  grid-template-columns: 150px minmax(0, 1fr);\n  gap: 14px;\n  color: #243f59;\n  font-size: 13px;\n}\n\n.empresas-base-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field > .Label,\n.empresas-base-modal:not(.empresas-negociaciones-base-modal) .empresas-form-options > label > .Label {\n  color: #294c6b;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.empresas-base-modal:not(.empresas-negociaciones-base-modal) .Input,\n.empresas-base-modal:not(.empresas-negociaciones-base-modal) .InputSelect,\n.empresas-base-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field input,\n.empresas-base-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field select {\n  min-height: 38px;\n  height: 38px;\n  padding: 7px 12px;\n  border: 1px solid #cbdce8;\n  border-radius: 9px;\n  color: #304f6b;\n  font-size: 14px;\n  line-height: 1.2;\n  transition: border-color .18s ease, box-shadow .18s ease, background-color .18s ease;\n}\n\n.empresas-base-modal:not(.empresas-negociaciones-base-modal) .Input:focus,\n.empresas-base-modal:not(.empresas-negociaciones-base-modal) .InputSelect:focus,\n.empresas-base-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field input:focus,\n.empresas-base-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field select:focus {\n  border-color: #1683b5;\n  box-shadow: 0 0 0 3px rgba(22, 131, 181, .13);\n}\n\n.empresas-base-modal:not(.empresas-negociaciones-base-modal) .empresas-modal-footer {\n  gap: 12px;\n  padding: 16px 26px 20px;\n  border-top: 1px solid #e5edf3;\n  background: #f8fbfd;\n}\n\n.empresas-base-modal:not(.empresas-negociaciones-base-modal) .empresas-modal-footer .btn {\n  min-height: 42px;\n  padding: 9px 22px;\n  border-radius: 9px;\n  font-weight: 600;\n}\n\n/* El formulario de empresa usa la misma base de modal, pero una distribución\n   compacta en escritorio para mostrar todos los campos sin scroll interno. */\n.empresas-base-modal.empresas-compact-modal:not(.empresas-negociaciones-base-modal) .modal-dialog {\n  width: min(900px, calc(100vw - 40px));\n  max-width: 900px;\n}\n\n.empresas-base-modal.empresas-compact-modal:not(.empresas-negociaciones-base-modal) .modal-content {\n  max-height: none;\n}\n\n.empresas-base-modal.empresas-compact-modal:not(.empresas-negociaciones-base-modal) .modal-body,\n.empresas-base-modal.empresas-compact-modal:not(.empresas-negociaciones-base-modal) .empresas-modal-content {\n  overflow: visible;\n  max-height: none;\n}\n\n.empresas-base-modal.empresas-compact-modal:not(.empresas-negociaciones-base-modal) .empresas-form-grid {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  column-gap: 22px;\n  row-gap: 9px;\n}\n\n.empresas-base-modal.empresas-compact-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field {\n  grid-template-columns: 150px minmax(0, 1fr);\n  gap: 8px;\n}\n\n.empresas-base-modal.empresas-compact-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field > .Label,\n.empresas-base-modal.empresas-compact-modal:not(.empresas-negociaciones-base-modal) .empresas-form-options > label > .Label {\n  min-width: 0;\n  white-space: nowrap;\n  font-size: 12px;\n  line-height: 1.2;\n}\n\n.empresas-base-modal.empresas-compact-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field input,\n.empresas-base-modal.empresas-compact-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field select,\n.empresas-base-modal.empresas-compact-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field .transportador-select__container {\n  min-width: 0;\n  width: 100%;\n}\n\n.empresas-base-modal.empresas-compact-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field-wide,\n.empresas-base-modal.empresas-compact-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field-full,\n.empresas-base-modal.empresas-compact-modal:not(.empresas-negociaciones-base-modal) .empresas-identification-row {\n  grid-column: 1 / -1;\n}\n\n.empresas-base-modal.empresas-compact-modal:not(.empresas-negociaciones-base-modal) .empresas-modal-content {\n  padding: 14px 24px 4px;\n}\n\n.empresas-base-modal.empresas-compact-modal:not(.empresas-negociaciones-base-modal) .empresas-modal-footer {\n  padding: 12px 24px 16px;\n}\n\n/* Variante compacta basada en el mockup clásico. Se mantiene separada de la\n   variante fresca para poder alternarlas desde la pantalla de empresas. */\n.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .modal-dialog {\n  width: min(620px, calc(100vw - 32px));\n  max-width: 620px;\n}\n\n.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .modal-content {\n  max-height: none;\n  border: 1px solid #dbe7ef;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .modal-header {\n  padding: 18px 22px 12px;\n}\n\n.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .modal-header h5 {\n  color: #526a83;\n  font-size: 20px;\n  font-weight: 500;\n}\n\n.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .modal-body,\n.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .empresas-modal-content {\n  max-height: none;\n  overflow: visible;\n}\n\n.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .empresas-modal-content {\n  padding: 8px 20px 0;\n}\n\n.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .empresas-form-grid {\n  grid-template-columns: 1fr;\n  gap: 7px;\n}\n\n.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field {\n  grid-template-columns: 145px minmax(0, 1fr);\n  gap: 8px;\n  color: #000;\n  font-size: 15px;\n}\n\n.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field > .Label,\n.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .empresas-form-options > label > .Label {\n  color: #000;\n  font-size: 15px;\n  font-weight: 700;\n  line-height: 1.15;\n  white-space: normal;\n}\n\n.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .Input,\n.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .InputSelect,\n.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field input,\n.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field select {\n  min-width: 0;\n  min-height: 20px;\n  height: 20px;\n  padding: 0 10px;\n  border: 1px solid #000;\n  border-radius: 4px;\n  color: #000;\n  font-size: 15px;\n  line-height: 1;\n}\n\n.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field .transportador-select__control {\n  min-height: 20px !important;\n  height: 20px !important;\n  border: 1px solid #000 !important;\n  border-radius: 4px !important;\n  box-shadow: none !important;\n}\n\n.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field .transportador-select__value-container,\n.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field .transportador-select__indicators {\n  height: 20px !important;\n  min-height: 20px !important;\n}\n\n.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field .transportador-select__value-container {\n  padding: 0 10px !important;\n  display: flex !important;\n  align-items: center !important;\n  overflow: hidden !important;\n}\n\n.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field .transportador-select__single-value,\n.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field .transportador-select__placeholder {\n  position: static !important;\n  transform: none !important;\n  display: flex !important;\n  align-items: center !important;\n  height: 20px !important;\n  margin: 0;\n  color: #777;\n  font-size: 15px;\n  line-height: 20px !important;\n}\n\n.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field .transportador-select__container {\n  margin-bottom: 0 !important;\n}\n\n.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field .transportador-select__input-container,\n.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field .transportador-select__input {\n  display: flex !important;\n  align-items: center !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  height: 20px !important;\n  line-height: 20px !important;\n}\n\n.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .empresas-identification-row {\n  grid-template-columns: minmax(0, 1fr) 18px minmax(90px, .32fr);\n  gap: 10px;\n}\n\n.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .empresas-form-options {\n  padding: 8px 0 0;\n}\n\n.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .empresas-modal-footer {\n  gap: 10px;\n  padding: 12px 20px 14px;\n}\n\n.empresas-base-modal.empresas-compacto-modal:not(.empresas-negociaciones-base-modal) .empresas-modal-footer .btn {\n  min-height: 40px;\n  padding: 8px 18px;\n  border-radius: 5px;\n  font-weight: 500;\n}\n\n.empresas-modal-variant-select {\n  width: auto;\n  min-width: 145px;\n}\n\n.empresas-mobile-cards {\n  display: none;\n}\n\n@media (max-width: 1199px) {\n  body.empresas-responsive-page #root {\n    margin-left: 0 !important;\n    overflow-x: hidden;\n  }\n\n  .empresas-page #layout-navbar.custom-navbar-admin {\n    background: transparent !important;\n    background-color: transparent !important;\n    background-image: none !important;\n    box-shadow: none !important;\n  }\n\n  .empresas-page #layout-navbar {\n    min-height: 64px;\n    padding: 4px 12px 4px 8px;\n  }\n\n  .empresas-page #layout-navbar .app-brand-link {\n    min-width: 0;\n    flex: 1 1 auto;\n  }\n\n  .empresas-page #layout-navbar .app-brand-link img {\n    width: min(190px, 100%);\n    height: 56px !important;\n    object-fit: contain;\n    object-position: left center;\n  }\n}\n\n@media (max-width: 767px) {\n  /* En móvil el modal funciona como bottom sheet: la X solo aparece\n     cuando el contenido está completamente expandido. */\n  .modal.empresas-negociaciones-base-modal .modal-dialog > .modal-content > .modal-header {\n    display: flex !important;\n    flex-direction: column;\n    align-items: stretch;\n    height: auto;\n    min-height: 26px;\n    padding: 8px 0 10px !important;\n    pointer-events: none;\n  }\n\n  .modal.empresas-negociaciones-base-modal .modal-dialog > .modal-content > .modal-header .btn-close {\n    position: absolute !important;\n    top: 50px !important;\n    right: 16px !important;\n    z-index: 1101 !important;\n    display: grid !important;\n    width: 38px;\n    height: 38px;\n    margin: 0;\n    padding: 0;\n    border: 0;\n    border-radius: 50%;\n    background-color: #edf2f8;\n    background-size: 14px;\n    opacity: 1;\n    pointer-events: auto;\n  }\n\n  .modal.empresas-negociaciones-base-modal .modal-dialog > .modal-content {\n    position: relative;\n  }\n\n  .empresas-base-modal .modal-content {\n    position: relative;\n    max-height: min(82dvh, 760px);\n  }\n\n  .empresas-base-modal .modal-body {\n    max-height: none !important;\n    overflow: hidden !important;\n  }\n\n  .empresas-base-modal .empresas-modal-content {\n    max-height: none;\n  }\n\n  .empresas-base-modal.responsive-modal-sheet-expanded .modal-content {\n    max-height: 100dvh;\n  }\n\n  /* Igual que el modal de permisos: el botón pertenece al modal-content y\n     queda fuera del área que hace scroll, no dentro del contenido. */\n  .modal.empresas-negociaciones-base-modal.responsive-modal-sheet-expanded\n    .modal-dialog > .modal-content > .modal-header .btn-close {\n    position: absolute !important;\n    top: 50px !important;\n    right: 16px !important;\n    z-index: 1101 !important;\n    display: grid !important;\n    width: 38px;\n    height: 38px;\n    margin: 0;\n    padding: 0;\n    border: 0;\n    border-radius: 50%;\n    background-color: #edf2f8;\n    background-size: 14px;\n    opacity: 1;\n  }\n\n  .modal.empresas-negociaciones-base-modal:not(.responsive-modal-sheet-expanded)\n    .modal-dialog > .modal-content > .modal-header .btn-close {\n    display: none !important;\n  }\n\n  .empresas-page {\n    min-height: 100dvh;\n  }\n\n  .empresas-page #layout-navbar {\n    min-height: 60px;\n    padding: 4px 8px;\n  }\n\n  .empresas-page #layout-navbar .app-brand-link img {\n    width: min(172px, 100%);\n    height: 48px !important;\n  }\n\n  .empresas-page .content-wrapper {\n    padding-bottom: calc(76px + env(safe-area-inset-bottom));\n  }\n\n  .empresas-heading {\n    align-items: stretch;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .empresas-heading-actions {\n    --empresas-control-height: 42px;\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .empresas-create-button { width: 100%; }\n\n  .empresas-heading h4 {\n    margin-bottom: 2px !important;\n    text-align: center;\n  }\n\n  .empresas-subtitle {\n    text-align: center;\n  }\n\n  .empresas-search {\n    width: 100%;\n  }\n\n  .empresas-table-wrapper {\n    max-height: calc(100dvh - 245px);\n  }\n\n  .empresas-table {\n    min-width: 0;\n  }\n\n  .empresas-table thead th,\n  .empresas-table tbody td {\n    padding: 12px 14px;\n  }\n\n  .empresas-table tbody td:first-child {\n    width: 72px;\n  }\n\n  .empresas-modal-backdrop {\n    align-items: flex-end;\n    padding: 0;\n  }\n\n  .empresas-modal {\n    width: 100%;\n    max-height: 94dvh;\n    border-radius: 18px 18px 0 0;\n  }\n\n  .empresas-modal-header { padding: 20px 18px 14px; }\n  .empresas-modal-header h5 { font-size: 18px; }\n  .empresas-base-modal:not(.empresas-negociaciones-base-modal) .modal-header { padding: 18px; }\n  .empresas-base-modal:not(.empresas-negociaciones-base-modal) .empresas-modal-content { padding: 18px; }\n  .empresas-base-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field { grid-template-columns: 1fr; gap: 6px; }\n  .empresas-base-modal:not(.empresas-negociaciones-base-modal) .empresas-modal-footer { padding: 14px 18px 18px; }\n  .empresas-base-modal.empresas-compact-modal:not(.empresas-negociaciones-base-modal) .empresas-form-grid {\n    grid-template-columns: 1fr;\n    row-gap: 10px;\n  }\n  .empresas-base-modal.empresas-compact-modal:not(.empresas-negociaciones-base-modal) .empresas-form-field {\n    grid-template-columns: 1fr;\n    gap: 6px;\n  }\n  .empresas-base-modal.empresas-compact-modal:not(.empresas-negociaciones-base-modal) .empresas-modal-content {\n    padding: 18px;\n  }\n  .empresas-modal-content form,\n  .empresas-negociaciones-modal > .empresas-negotiation-grid,\n  .empresas-negociaciones-modal > .empresas-negotiation-checks,\n  .empresas-negociaciones-modal > .empresas-notes { padding-left: 18px; padding-right: 18px; }\n  .empresas-modal-content { padding-left: 18px; padding-right: 18px; }\n  .empresas-form-grid,\n  .empresas-negotiation-grid { grid-template-columns: 1fr; gap: 12px; }\n  .empresas-form-field,\n  .empresas-negotiation-grid label,\n  .empresas-form-options label,\n  .empresas-notes { grid-template-columns: 1fr; gap: 5px; }\n  .empresas-identification-row { grid-template-columns: minmax(0, 1fr) 14px minmax(68px, .32fr); gap: 6px; }\n  .empresas-form-field-wide { grid-column: auto; }\n  .empresas-form-options { padding-left: 0; padding-right: 0; }\n  .empresas-report-type { flex-wrap: wrap; gap: 8px 14px; min-width: 0; }\n  .empresas-modal-footer {\n    margin-left: 18px;\n    margin-right: 18px;\n    padding: 18px 0;\n  }\n  .empresas-negotiation-checks { flex-direction: column; gap: 5px; }\n  .empresas-negotiation-table { margin-left: 18px; margin-right: 18px; }\n}\n\n/* Empresas en móvil: misma composición de los maestros responsive, con las\n   acciones apiladas y la grilla contenida dentro de su propio scroll. */\n@media (max-width: 767px) {\n  body.empresas-responsive-page {\n    overflow-x: hidden;\n    background: #f5f7fb;\n  }\n\n  body.empresas-responsive-page .layout-wrapper,\n  body.empresas-responsive-page .layout-container,\n  body.empresas-responsive-page .layout-page,\n  body.empresas-responsive-page .content-wrapper {\n    width: 100%;\n    min-width: 0;\n    overflow-x: hidden;\n  }\n\n  .empresas-page .content-wrapper {\n    padding-bottom: calc(78px + env(safe-area-inset-bottom));\n  }\n\n  .empresas-page .container-fluid {\n    width: 100%;\n    max-width: 100%;\n    padding: 14px 12px calc(18px + env(safe-area-inset-bottom));\n  }\n\n  .empresas-mobile-cards {\n    display: grid;\n    gap: 10px;\n    width: 100%;\n    min-width: 0;\n    margin-bottom: 14px;\n  }\n\n  .empresa-mobile-card {\n    box-sizing: border-box;\n    width: 100%;\n    min-width: 0;\n    padding: 13px;\n    border: 1px solid #dbe6ef;\n    border-radius: 10px;\n    background: #fff;\n    box-shadow: 0 3px 12px rgba(31, 55, 80, .08);\n  }\n\n  .empresa-mobile-card-header,\n  .empresa-mobile-card-title,\n  .empresa-mobile-card-details,\n  .empresa-mobile-card-actions {\n    display: flex;\n    align-items: center;\n  }\n\n  .empresa-mobile-card-header {\n    justify-content: space-between;\n    gap: 10px;\n  }\n\n  .empresa-mobile-card-title {\n    min-width: 0;\n    gap: 9px;\n  }\n\n  .empresa-mobile-card-title > div {\n    display: grid;\n    min-width: 0;\n    gap: 2px;\n  }\n\n  .empresa-mobile-card-title strong,\n  .empresa-mobile-card-title span,\n  .empresa-mobile-card-details span {\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .empresa-mobile-card-title strong {\n    color: #294b69;\n    font-size: 14px;\n    line-height: 1.25;\n  }\n\n  .empresa-mobile-card-title > div > span {\n    color: #8192a2;\n    font-size: 12px;\n  }\n\n  .empresa-mobile-card-icon {\n    display: grid;\n    flex: 0 0 34px;\n    width: 34px;\n    height: 34px;\n    border-radius: 9px;\n    background: #eaf3f8;\n    color: #006699;\n    font-size: 19px;\n    place-items: center;\n  }\n\n  .empresa-mobile-card-id {\n    flex: 0 0 auto;\n    color: #71859a;\n    font-size: 11px;\n    font-weight: 700;\n  }\n\n  .empresa-mobile-card-details {\n    flex-wrap: wrap;\n    gap: 7px 14px;\n    margin: 11px 0;\n    color: #60788d;\n    font-size: 12px;\n  }\n\n  .empresa-mobile-card-details > div {\n    display: flex;\n    min-width: 0;\n    flex: 1 1 140px;\n    align-items: center;\n    gap: 5px;\n  }\n\n  .empresa-mobile-card-details i {\n    flex: 0 0 auto;\n    color: #1979a6;\n    font-size: 15px;\n  }\n\n  .empresa-mobile-card-actions {\n    gap: 8px;\n    padding-top: 10px;\n    border-top: 1px solid #edf2f6;\n  }\n\n  .empresa-mobile-action {\n    box-sizing: border-box;\n    display: inline-flex;\n    flex: 1 1 0;\n    min-width: 0;\n    min-height: 36px;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    padding: 7px 9px;\n    border: 1px solid transparent;\n    border-radius: 6px;\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 1.1;\n    white-space: nowrap;\n  }\n\n  .empresa-mobile-action-edit {\n    border-color: #cbdce8;\n    background: #fff;\n    color: #35617d;\n  }\n\n  .empresa-mobile-action-negociaciones {\n    border-color: #006699;\n    background: #006699;\n    color: #fff;\n  }\n\n  .empresa-mobile-action:focus-visible {\n    outline: 3px solid rgba(0, 102, 153, .2);\n    outline-offset: 1px;\n  }\n\n  .empresas-heading {\n    display: flex;\n    align-items: stretch;\n    gap: 12px;\n    margin: 0 0 16px;\n  }\n\n  .empresas-heading > div:first-child {\n    padding: 0 4px;\n  }\n\n  .empresas-heading h4 {\n    margin: 0 0 4px !important;\n    color: #294b69;\n    font-size: 20px;\n    line-height: 1.15;\n    text-align: center;\n  }\n\n  .empresas-subtitle {\n    font-size: 12px;\n    line-height: 1.3;\n    text-align: center;\n  }\n\n  .empresas-heading-actions {\n    display: grid;\n    grid-template-columns: 1fr;\n    width: 100%;\n    gap: 10px;\n  }\n\n  .empresas-modal-variant-select,\n  .empresas-heading-actions .empresas-create-button,\n  .empresas-search {\n    box-sizing: border-box;\n    width: 100%;\n    min-width: 0;\n    height: 40px;\n    min-height: 40px;\n    margin: 0;\n  }\n\n  .empresas-modal-variant-select {\n    padding: 7px 12px;\n    border: 1px solid #d2dee9;\n    border-radius: 7px;\n    background-color: #fff;\n    color: #526a83;\n    font-size: 14px;\n    line-height: 24px;\n  }\n\n  .empresas-heading-actions .empresas-create-button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    box-sizing: border-box;\n    min-height: 40px;\n    height: 40px;\n    padding: 0 14px;\n    border-radius: 6px;\n    font-size: 14px;\n    line-height: 1;\n    white-space: nowrap;\n  }\n\n  .empresas-search {\n    border-color: #d2dee9;\n    border-radius: 7px;\n    display: flex;\n    align-items: stretch;\n  }\n\n  .empresas-search .input-group-text {\n    width: 42px;\n    justify-content: center;\n    padding: 0;\n  }\n\n  .empresas-search .form-control {\n    box-sizing: border-box;\n    min-width: 0;\n    height: 38px;\n    min-height: 38px;\n    padding: 7px 10px;\n    font-size: 14px;\n    line-height: 24px;\n  }\n\n  .empresas-search .input-group-text {\n    box-sizing: border-box;\n    height: 38px;\n    min-height: 38px;\n    align-items: center;\n  }\n\n  .empresas-table-card {\n    display: none;\n  }\n\n  .empresas-mobile-cards .empresas-state {\n    box-sizing: border-box;\n    width: 100%;\n    padding: 28px 14px !important;\n    border: 1px solid #dbe6ef;\n    border-radius: 10px;\n    background: #fff;\n  }\n\n  .empresas-table-card {\n    border-radius: 10px;\n    box-shadow: 0 3px 12px rgba(31, 55, 80, .08);\n  }\n\n  .empresas-table-wrapper {\n    max-height: calc(100dvh - 300px);\n    overflow-x: auto;\n    overflow-y: auto;\n    overscroll-behavior: contain;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .empresas-table {\n    width: max-content;\n    min-width: 720px;\n    table-layout: fixed;\n  }\n\n  .empresas-table thead th {\n    position: sticky;\n    top: 0;\n    padding: 11px 14px;\n    font-size: 11px;\n    letter-spacing: .03em;\n  }\n\n  .empresas-table tbody td {\n    max-width: 230px;\n    padding: 13px 14px;\n    font-size: 13px;\n    line-height: 1.3;\n    white-space: normal;\n    overflow-wrap: anywhere;\n  }\n\n  .empresas-table th:first-child,\n  .empresas-table td:first-child {\n    width: 68px;\n  }\n\n  .empresas-table th:nth-child(2),\n  .empresas-table td:nth-child(2) {\n    width: 235px;\n  }\n\n  .empresas-table th:nth-child(3),\n  .empresas-table td:nth-child(3) {\n    width: 150px;\n  }\n\n  .empresas-actions-heading,\n  .empresas-actions-cell {\n    width: 64px;\n  }\n\n  .empresas-result-count {\n    padding: 9px 12px;\n    font-size: 11px;\n  }\n\n  /* Bottom sheets de Empresas: el header y el footer permanecen visibles y\n     solo se desplaza el contenido del formulario. Las reglas anteriores de\n     la base ocultaban este scroll con overflow:hidden. */\n  .modal.empresas-base-modal .modal-dialog > .modal-content {\n    display: flex;\n    flex-direction: column;\n    height: min(82dvh, 760px);\n    max-height: min(82dvh, 760px);\n    min-height: 0;\n  }\n\n  .modal.empresas-base-modal.responsive-modal-sheet-expanded\n    .modal-dialog > .modal-content {\n    height: 100dvh;\n    max-height: 100dvh;\n  }\n\n  .modal.empresas-base-modal .modal-dialog > .modal-content > .modal-body {\n    display: flex;\n    flex: 1 1 auto;\n    flex-direction: column;\n    min-height: 0;\n    height: auto;\n    max-height: none !important;\n    overflow: hidden !important;\n  }\n\n  .modal.empresas-base-modal:not(.empresas-negociaciones-base-modal)\n    .empresas-modal-shell,\n  .modal.empresas-base-modal:not(.empresas-negociaciones-base-modal)\n    .empresas-modal-shell > form {\n    flex: 1 1 auto;\n    height: 100%;\n    min-height: 0;\n  }\n\n  .modal.empresas-base-modal:not(.empresas-negociaciones-base-modal)\n    .modal-dialog > .modal-content > .modal-body > .empresas-modal-shell {\n    height: 0;\n  }\n\n  .modal.empresas-base-modal:not(.empresas-negociaciones-base-modal)\n    .empresas-modal-content {\n    flex: 1 1 auto;\n    height: 0;\n    min-height: 0;\n    max-height: none !important;\n    overflow-x: hidden !important;\n    overflow-y: auto !important;\n    -webkit-overflow-scrolling: touch;\n    overscroll-behavior: contain;\n  }\n\n  .modal.empresas-base-modal:not(.empresas-negociaciones-base-modal)\n    .empresas-modal-footer {\n    flex: 0 0 auto;\n    position: relative;\n    z-index: 2;\n  }\n\n  /* Empresa fresca y compacta usan el mismo modelo de desplazamiento que\n     negociaciones: un único scroll en modal-body. Esto evita que el estado\n     colapsado del bottom sheet bloquee el gesto vertical. */\n  .modal.empresas-base-modal:not(.empresas-negociaciones-base-modal)\n    .modal-dialog > .modal-content > .modal-body {\n    display: block !important;\n    height: 0 !important;\n    min-height: 0;\n    overflow-x: hidden !important;\n    overflow-y: auto !important;\n    -webkit-overflow-scrolling: touch;\n    overscroll-behavior: contain;\n    touch-action: pan-y;\n  }\n\n  .modal.empresas-base-modal:not(.empresas-negociaciones-base-modal)\n    .empresas-modal-shell,\n  .modal.empresas-base-modal:not(.empresas-negociaciones-base-modal)\n    .empresas-modal-shell > form {\n    display: block;\n    height: auto;\n    min-height: 0;\n    overflow: visible;\n  }\n\n  .modal.empresas-base-modal:not(.empresas-negociaciones-base-modal)\n    .empresas-modal-content {\n    height: auto;\n    overflow: visible !important;\n  }\n\n  .modal.empresas-base-modal:not(.empresas-negociaciones-base-modal)\n    .empresas-modal-footer {\n    position: sticky;\n    bottom: 0;\n    z-index: 3;\n    background: linear-gradient(180deg, rgba(248, 251, 253, .88) 0%, #f8fbfd 28%);\n  }\n\n  /* En móvil las dos variantes de empresa usan controles táctiles cómodos;\n     la variante compacta conserva su layout, pero no sus inputs de 20px. */\n  .modal.empresas-base-modal.empresas-compacto-modal\n    .empresas-form-field input,\n  .modal.empresas-base-modal.empresas-compacto-modal\n    .empresas-form-field select,\n  .modal.empresas-base-modal.empresas-compacto-modal\n    .empresas-form-field .transportador-select__control,\n  .modal.empresas-base-modal.empresas-compacto-modal\n    .empresas-form-field .transportador-select__value-container,\n  .modal.empresas-base-modal.empresas-compacto-modal\n    .empresas-form-field .transportador-select__indicators {\n    box-sizing: border-box;\n    height: 38px !important;\n    min-height: 38px !important;\n  }\n\n  .modal.empresas-base-modal.empresas-compacto-modal\n    .empresas-form-field input,\n  .modal.empresas-base-modal.empresas-compacto-modal\n    .empresas-form-field select {\n    padding: 7px 12px;\n    border: 1px solid #cbdce8;\n    border-radius: 9px;\n    color: #304f6b;\n    font-size: 14px;\n    line-height: 1.2;\n  }\n\n  /* Negociaciones: el formulario completo es el área scrollable, no el\n     modal-body bloqueado por la base. */\n  .modal.empresas-negociaciones-base-modal\n    .modal-dialog > .modal-content > .modal-body {\n    display: block !important;\n    flex: 1 1 auto;\n    height: 0 !important;\n    min-height: 0;\n    max-height: none !important;\n    overflow-x: hidden !important;\n    overflow-y: auto !important;\n    -webkit-overflow-scrolling: touch;\n    overscroll-behavior: contain;\n    touch-action: pan-y;\n  }\n\n  .modal.empresas-negociaciones-base-modal\n    .empresas-negociaciones-modal.monitoreo-modern {\n    display: flex;\n    flex: 0 0 auto;\n    height: auto !important;\n    min-height: 100%;\n    max-height: none;\n    padding: 8px 14px calc(14px + env(safe-area-inset-bottom));\n    overflow-x: hidden !important;\n    overflow-y: visible !important;\n    touch-action: pan-y;\n  }\n\n  .modal.empresas-negociaciones-base-modal\n    .empresas-negociaciones-modal .monitoreo-form-card {\n    flex: 0 0 auto;\n    margin: 0;\n    padding: 12px 10px;\n    border: 1px solid #e0eaf3;\n    border-radius: 14px;\n    box-shadow: 0 4px 14px rgba(31, 55, 80, .06);\n  }\n\n  .modal.empresas-negociaciones-base-modal\n    .empresas-negotiation-grid {\n    gap: 9px;\n  }\n\n  .modal.empresas-negociaciones-base-modal\n    .empresas-negotiation-field {\n    grid-template-columns: 132px minmax(0, 1fr);\n    gap: 8px;\n    font-size: 12px;\n  }\n\n  .modal.empresas-negociaciones-base-modal\n    .empresas-negotiation-field > span,\n  .modal.empresas-negociaciones-base-modal\n    .empresas-negotiation-notes > span {\n    line-height: 1.2;\n  }\n\n  .modal.empresas-negociaciones-base-modal\n    .empresas-negotiation-checks {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr);\n    flex: 0 0 auto;\n    justify-items: start;\n    gap: 10px;\n    margin: 12px 0 0;\n    padding: 0 4px;\n  }\n\n  .modal.empresas-negociaciones-base-modal\n    .empresas-negotiation-checks .empresas-switch {\n    width: 100%;\n    min-height: 28px;\n  }\n\n  .modal.empresas-negociaciones-base-modal\n    .empresas-negotiation-notes {\n    display: grid;\n    flex: 0 0 auto;\n    grid-template-columns: 132px minmax(0, 1fr);\n    gap: 8px;\n    margin: 12px 0 0;\n    padding: 0 4px !important;\n  }\n\n  .modal.empresas-negociaciones-base-modal\n    .empresas-negotiation-notes .TextAreaReportSe {\n    min-height: 72px;\n    height: 72px;\n  }\n\n  .modal.empresas-negociaciones-base-modal\n    .empresas-modal-footer {\n    display: flex;\n    flex: 0 0 auto;\n    flex-wrap: wrap;\n    gap: 8px;\n    margin: 14px 4px 0;\n    padding: 12px 0 calc(4px + env(safe-area-inset-bottom));\n    position: sticky;\n    bottom: 0;\n    z-index: 3;\n    background: linear-gradient(180deg, rgba(239, 245, 252, .88) 0%, #eff5fc 28%);\n  }\n\n  .modal.empresas-negociaciones-base-modal\n    .empresas-modal-footer .Button {\n    box-sizing: border-box;\n    flex: 1 1 150px;\n    min-width: 0;\n    min-height: 42px;\n  }\n\n  .modal.empresas-negociaciones-base-modal\n    .empresas-modal-footer .monitoreo-primary-btn {\n    min-width: 0;\n  }\n\n  /* Presentación basada en el mockup móvil: bloques agrupados, título con\n     contexto y controles táctiles consistentes. */\n  .modal.empresas-base-modal .modal-header {\n    padding: 8px 18px 12px !important;\n  }\n\n  .modal.empresas-base-modal .modal-header .modal-title {\n    padding: 6px 52px 8px 18px;\n  }\n\n  .empresas-modal-heading {\n    max-width: 100%;\n    align-items: flex-start;\n    gap: 9px;\n  }\n\n  .empresas-modal-heading > i {\n    width: 30px;\n    height: 30px;\n    flex-basis: 30px;\n    font-size: 18px;\n  }\n\n  .empresas-modal-heading strong {\n    font-size: 17px;\n    line-height: 1.2;\n  }\n\n  .empresas-modal-heading small {\n    display: block;\n    font-size: 11px;\n    line-height: 1.3;\n  }\n\n  .modal.empresas-base-modal:not(.empresas-negociaciones-base-modal)\n    .empresas-form-grid {\n    display: grid;\n    gap: 10px;\n  }\n\n  .modal.empresas-base-modal:not(.empresas-negociaciones-base-modal)\n    .empresas-form-section {\n    display: block;\n    min-width: 0;\n    padding: 10px;\n    border: 1px solid #e1ebf4;\n    border-radius: 15px;\n    background: linear-gradient(180deg, #f5f9fd 0%, #ffffff 44%);\n  }\n\n  .modal.empresas-base-modal:not(.empresas-negociaciones-base-modal)\n    .empresas-form-section-title {\n    display: flex;\n    align-items: center;\n    gap: 7px;\n    margin: 0 0 8px;\n    color: #214d76;\n    font-size: 13px;\n    font-weight: 800;\n  }\n\n  .modal.empresas-base-modal:not(.empresas-negociaciones-base-modal)\n    .empresas-form-section-title i {\n    color: #0874a7;\n    font-size: 17px;\n  }\n\n  .modal.empresas-base-modal:not(.empresas-negociaciones-base-modal)\n    .empresas-form-section-grid {\n    display: grid;\n    gap: 9px;\n  }\n\n  .modal.empresas-base-modal:not(.empresas-negociaciones-base-modal)\n    .empresas-form-section .empresas-identification-row {\n    margin-top: 9px;\n  }\n\n  .modal.empresas-negociaciones-base-modal\n    .empresas-negotiation-section-title {\n    display: flex;\n    align-items: center;\n    gap: 7px;\n    margin: 0 0 8px;\n    color: #214d76;\n    font-size: 13px;\n    font-weight: 800;\n  }\n\n  .modal.empresas-negociaciones-base-modal\n    .empresas-negotiation-section-title i {\n    color: #0874a7;\n    font-size: 17px;\n  }\n\n  .modal.empresas-negociaciones-base-modal\n    .empresas-negotiation-main-section {\n    padding: 10px;\n    border: 1px solid #e1ebf4;\n    border-radius: 15px;\n    background: linear-gradient(180deg, #f5f9fd 0%, #ffffff 44%);\n  }\n\n  .modal.empresas-negociaciones-base-modal\n    .empresas-negotiation-main-section .monitoreo-form-card {\n    padding: 2px 0 0;\n    border: 0;\n    background: transparent;\n    box-shadow: none;\n  }\n\n  .modal.empresas-negociaciones-base-modal\n    .empresas-negotiation-notes {\n    margin-top: 14px;\n    padding: 12px 10px !important;\n    border: 1px solid #e1ebf4;\n    border-radius: 15px;\n    background: linear-gradient(180deg, #f5f9fd 0%, #ffffff 44%);\n  }\n\n  .modal.empresas-negociaciones-base-modal\n    .empresas-negotiation-checks {\n    margin-top: 12px;\n    padding: 10px 12px;\n    border: 1px solid #e1ebf4;\n    border-radius: 14px;\n    background: #f5f9fd;\n  }\n\n  /* En Empresas el patrón del mockup es una hoja móvil completa. La altura\n     explícita evita que el estado inicial del drag deje el modal sin área\n     desplazable. */\n  .modal.empresas-base-modal {\n    height: 100dvh !important;\n    max-height: 100dvh !important;\n    min-height: 100dvh !important;\n    align-items: flex-end !important;\n  }\n\n  .modal.empresas-base-modal .modal-dialog {\n    height: 100dvh !important;\n    max-height: 100dvh !important;\n    min-height: 100dvh !important;\n  }\n\n  .modal.empresas-base-modal .modal-dialog > .modal-content {\n    height: 100dvh !important;\n    max-height: 100dvh !important;\n    min-height: 100dvh;\n    border-radius: 22px 22px 0 0;\n  }\n\n  .modal.empresas-base-modal .modal-dialog > .modal-content > .modal-header {\n    flex: 0 0 auto;\n  }\n\n  .modal.empresas-base-modal .modal-dialog > .modal-content > .modal-body {\n    flex: 0 0 auto !important;\n    height: calc(100dvh - 92px) !important;\n    max-height: calc(100dvh - 92px) !important;\n    min-height: 0 !important;\n    overflow-x: hidden !important;\n    overflow-y: scroll !important;\n    -webkit-overflow-scrolling: touch;\n    overscroll-behavior-y: contain;\n    touch-action: pan-y;\n  }\n\n  .modal.empresas-base-modal .modal-header .btn-close,\n  .modal.empresas-base-modal .responsive-modal-sheet-close {\n    position: absolute !important;\n    top: 50px !important;\n    right: 16px !important;\n    z-index: 1101 !important;\n    display: grid !important;\n    width: 38px;\n    height: 38px;\n    margin: 0;\n    padding: 0;\n    border: 0;\n    border-radius: 50%;\n    background-color: #edf2f8;\n    background-size: 14px;\n    color: #30445d;\n    opacity: 1;\n    pointer-events: auto;\n  }\n\n  .modal.empresas-base-modal .empresas-modal-shell,\n  .modal.empresas-base-modal .empresas-modal-shell > form,\n  .modal.empresas-base-modal .empresas-modal-content,\n  .modal.empresas-base-modal .empresas-negociaciones-modal.monitoreo-modern {\n    min-height: 0;\n  }\n\n  /* Reactstrap aplica className al modal-dialog. Estas reglas directas son\n     las que gobiernan realmente el contenido de Empresas en móvil. */\n  .empresas-base-modal {\n    height: 100dvh !important;\n    max-height: 100dvh !important;\n    min-height: 100dvh !important;\n  }\n\n  .empresas-base-modal > .modal-content {\n    display: flex !important;\n    flex-direction: column;\n    height: 100dvh !important;\n    max-height: 100dvh !important;\n    min-height: 100dvh;\n    overflow: hidden;\n    border-radius: 22px 22px 0 0;\n  }\n\n  .empresas-base-modal > .modal-content > .modal-header {\n    flex: 0 0 auto;\n  }\n\n  .empresas-base-modal > .modal-content > .modal-body {\n    display: flex !important;\n    flex: 1 1 auto !important;\n    flex-direction: column;\n    height: auto !important;\n    min-height: 0 !important;\n    max-height: none !important;\n    overflow: hidden !important;\n  }\n\n  .empresas-base-modal:not(.empresas-negociaciones-base-modal)\n    > .modal-content > .modal-body {\n    padding: 0 !important;\n  }\n\n  .empresas-base-modal:not(.empresas-negociaciones-base-modal)\n    .empresas-modal-shell,\n  .empresas-base-modal:not(.empresas-negociaciones-base-modal)\n    .empresas-modal-shell > form {\n    display: flex !important;\n    flex: 1 1 auto;\n    flex-direction: column;\n    width: 100%;\n    height: 100%;\n    min-height: 0;\n  }\n\n  .empresas-base-modal:not(.empresas-negociaciones-base-modal)\n    .empresas-modal-content {\n    flex: 1 1 auto !important;\n    height: 0 !important;\n    min-height: 0 !important;\n    max-height: none !important;\n    overflow-x: hidden !important;\n    overflow-y: auto !important;\n    -webkit-overflow-scrolling: touch;\n    overscroll-behavior: contain;\n    touch-action: pan-y;\n  }\n\n  .empresas-base-modal:not(.empresas-negociaciones-base-modal)\n    .empresas-modal-footer {\n    position: relative !important;\n    flex: 0 0 auto !important;\n    bottom: auto;\n    margin-top: 0;\n    z-index: 2;\n  }\n\n  .empresas-base-modal.empresas-negociaciones-base-modal\n    > .modal-content > .modal-body {\n    display: block !important;\n    flex: 0 0 auto !important;\n    height: calc(100dvh - 92px) !important;\n    max-height: calc(100dvh - 92px) !important;\n    overflow-x: hidden !important;\n    overflow-y: scroll !important;\n    -webkit-overflow-scrolling: touch;\n    overscroll-behavior: contain;\n    touch-action: pan-y;\n  }\n\n  .empresas-base-modal.empresas-negociaciones-base-modal\n    .empresas-negociaciones-modal.monitoreo-modern {\n    display: flex !important;\n    flex: 0 0 auto;\n    height: auto !important;\n    min-height: 100%;\n    overflow: visible !important;\n  }\n\n  .empresas-base-modal.empresas-negociaciones-base-modal\n    .empresas-modal-footer {\n    position: relative !important;\n    bottom: auto;\n    margin-top: 14px;\n  }\n\n  /* Empresa: el footer no debe tapar campos. El formulario reproduce el\n     patrón del modal de seguimiento: contenido flexible desplazable y\n     acciones fuera del área de scroll. */\n  .modal.empresas-base-modal:not(.empresas-negociaciones-base-modal)\n    .modal-dialog > .modal-content > .modal-body {\n    display: flex !important;\n    flex-direction: column;\n  }\n\n  .modal.empresas-base-modal:not(.empresas-negociaciones-base-modal)\n    .empresas-modal-shell {\n    display: flex;\n    flex: 1 1 auto;\n    flex-direction: column;\n    width: 100%;\n    height: 100%;\n    min-height: 0;\n  }\n\n  .modal.empresas-base-modal:not(.empresas-negociaciones-base-modal)\n    .empresas-modal-shell > form {\n    display: flex;\n    flex: 1 1 auto;\n    flex-direction: column;\n    width: 100%;\n    height: 100%;\n    min-height: 0;\n  }\n\n  .modal.empresas-base-modal:not(.empresas-negociaciones-base-modal)\n    .empresas-modal-content {\n    flex: 1 1 auto;\n    height: 0;\n    min-height: 0;\n    overflow-x: hidden !important;\n    overflow-y: auto !important;\n    -webkit-overflow-scrolling: touch;\n    overscroll-behavior: contain;\n  }\n\n  .modal.empresas-base-modal:not(.empresas-negociaciones-base-modal)\n    .empresas-modal-footer {\n    flex: 0 0 auto;\n    position: relative;\n    bottom: auto;\n    margin-top: 0;\n  }\n\n  /* Bottom sheet compartido: inicia parcialmente abierto y solo se vuelve\n     fullscreen después del gesto de arrastre hacia arriba. */\n  .modal.empresas-base-modal,\n  .modal.empresas-base-modal .modal-dialog,\n  .empresas-base-modal {\n    height: auto !important;\n    min-height: 0 !important;\n    max-height: none !important;\n  }\n\n  .empresas-base-modal > .modal-content {\n    height: min(82dvh, 760px) !important;\n    max-height: min(82dvh, 760px) !important;\n    min-height: 0 !important;\n    border-radius: 22px 22px 0 0;\n  }\n\n  .modal.responsive-modal-sheet-expanded .empresas-base-modal > .modal-content {\n    height: 100dvh !important;\n    max-height: 100dvh !important;\n    min-height: 100dvh !important;\n    border-radius: 0;\n  }\n\n  .empresas-base-modal:not(.empresas-negociaciones-base-modal)\n    > .modal-content > .modal-body,\n  .empresas-base-modal.empresas-negociaciones-base-modal\n    > .modal-content > .modal-body {\n    height: calc(min(82dvh, 760px) - 92px) !important;\n    max-height: calc(min(82dvh, 760px) - 92px) !important;\n  }\n\n  .modal.responsive-modal-sheet-expanded\n    .empresas-base-modal:not(.empresas-negociaciones-base-modal)\n    > .modal-content > .modal-body,\n  .modal.responsive-modal-sheet-expanded\n    .empresas-base-modal.empresas-negociaciones-base-modal\n    > .modal-content > .modal-body {\n    height: calc(100dvh - 92px) !important;\n    max-height: calc(100dvh - 92px) !important;\n  }\n\n  .modal:not(.responsive-modal-sheet-expanded)\n    .empresas-base-modal .modal-header .btn-close,\n  .modal:not(.responsive-modal-sheet-expanded)\n    .empresas-base-modal .responsive-modal-sheet-close {\n    display: none !important;\n  }\n\n  .modal.responsive-modal-sheet-expanded\n    .empresas-base-modal .modal-header .btn-close,\n  .modal.responsive-modal-sheet-expanded\n    .empresas-base-modal .responsive-modal-sheet-close {\n    display: grid !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
